<template>
	<div class="container-fluid my-Leads-md pt-3" v-if="reloadCompenent">
		
		<!-- demo root element -->
		<div id="demo" style="padding: 6px 10px 20px 10px;">
			
		<div>
			<h3>Qualification</h3>
		</div>
		<section class="scrollable wrapper" style="text-align: center;">
			<div class="fakeloader" style="position: absolute; width: 100%; height: 100%; top: 0px; left: 0px; background-color: rgb(255, 255, 255); display: none; z-index: 999899999;">
				<div class="fl" style="position: absolute; left: 683px; top: 218px;">
					<img src="img/ajax-loader.gif">
				</div>
			</div>
			<br>
			<div class="dispatch">
				<img src="img/lead-dispatch.png" style="width: 25%;" />
				<p style="width: 56%; margin: 15px auto;">{{ $t('HandleInbound')}}</p>
				<button class="btn-clickstart-md" href="#" @click="showDspatcher">{{ $t('ClickToStart')}}</button>
			</div>
		</section>
			
			
			
			
			<!-- :totalLead="totalLead" -->
			
			
			
			<!--b-modal id="bv-modal-changeStatus" centered size="lg" no-close-on-backdrop hide-footer hide-header>
			</b-modal-->

			<div class="oml-detailsLead-overlay" @click="activeDetailsLead = false" v-if="activeDetailsLead"></div>
			<div class="oml-detailsLead-popup active" v-if="dispatcher">
				<div class="oml-detailsLead-container">
					<div class="oml-detailsLead-header">
						<div class="oml-detailsLeadHeader-left">
							<button class="oml-detailsLead-closeBtn" @click="dispatcher = false">
								<i class="ri-close-line"></i>
							</button>
						</div>
						<div class="oml-detailsLeadHeader-right">

							<div class="oml-detailsLead-nav">
								<button @click="switchLeads('prev')" v-if="selectedLead.id > 0" class="oml-detailsLead-prev"><i class="ri-arrow-left-s-line"></i></button>
								<button @click="switchLeads('next')" v-if="gridData.length != selectedLead.id + 1" class="oml-detailsLead-next"><i class="ri-arrow-right-s-line"></i></button>
							</div>
							<b-dropdown 
								size="sm"  
								variant="link" 
								toggle-class="text-decoration-none" 
								right 
								no-caret 
								:class="[deleteSendToBtn ? 'margin-auto show' : 'margin-auto']"
								ref="dropdownFicheLead"
							>
								<template #button-content>
									<i class="ri-more-2-fill" @click="deleteSendToBtn = !deleteSendToBtn"></i>
								</template>
								
								<b-dropdown-form class="sendTo-btn" v-if="!$store.state.active || ($store.state.active && 'send to' in $store.state.permissions)">
									<div><i class="fa fa-street-view"></i> {{$t('SendTo')}} </div><i class="ri-arrow-right-s-fill"></i>
									<div class="oml-detailsLeadSendTo-workspaces">
										<div class="oml-detailsLeadSendToWorkspace-content">
											<h3>{{$t('Workspaces')}} </h3>
											<div v-if="$store.state.WorkSpaces.length == 1">
												<div class="oml-infos-box d-flex align-items-center"><p>{{$t('msgCreateWorkspace')}}</p></div>
												<div class="text-center"><button class="oml-btn">{{$t('create')}}</button></div>
											</div>
											<ul v-else>
												<template  v-for="workspace in $store.state.WorkSpaces">
													<li 
														class="checked"  
														:key="workspace.id"
													>
														<div v-if="workspace.id != $store.state.SelectedClient" class="workspace-item" @click="bulkActionSelectWorkspace(workspace.id,selectedLead.entry.id)">
															<i v-if="bulkSendTo.worspace_id == workspace.id" class="ri-check-line"></i>
															<span>{{workspace.title}}</span>
														</div>
														
														<span v-if="workspace.id != $store.state.SelectedClient" class="workspace-total">{{workspace.tag}}</span>
													</li>
												</template>
											</ul>
										</div>
										<div class="oml-detailsLeadSendToWorkspace-footer">
											<template v-if="$store.state.WorkSpaces.length == 1">
												<div class="bulkBtn disabled"><i class="icon icon-send"></i>{{$t('Send')}}</div>
											</template>
											<template v-else>
												<div class="bulkBtn" @click="notifyMe($t('chooseWorkspace'), 'warn')" v-if="bulkSendTo.worspace_id == '' || bulkSendTo.worspace_id == null"><i class="icon icon-send"></i>{{$t('Send')}}</div>
												<div class="submitBtn" @click="bulkActionSend" v-else><i class="icon icon-send"></i>{{$t('Send')}}</div>
											</template>
										</div>
									</div>
								
								</b-dropdown-form>
								
								<b-dropdown-item v-if="!$store.state.active || ($store.state.active && 'delete leads' in $store.state.permissions)" class="delete-btn" @click="$bvModal.show('modal-delete-lead')"><i class="ri-delete-bin-6-line"></i> {{ $t('Delete') }}</b-dropdown-item>
							</b-dropdown>
						</div>
						
					</div>

					<div class="oml-detailsLead-body">
						<div class="oml-detailsLeadBody-left">
							<div class="oml-detailsLeadLeft-header">
								<div class="oml-detailsLeadLeft-infos">
									<div class="oml-detailsLeadLeft-name">
										<h3 v-if="selectedLead.entry.full_name != ''">{{ selectedLead.entry.full_name | capitalize }}</h3>
										<!--button @click="doCall = !doCall" title="Popover Call" class="call-btn"><i class="ri-phone-line"></i></button-->
										<a :href="'tel:' + selectedLead.entry.personal_phone.split('.').join('')" title="Popover Call" class="call-btn"><i class="ri-phone-line"></i></a>
										<a :href="'https://wa.me/' + selectedLead.entry.personal_phone.split('.').join('')" target="_blank" class="whatsapp-btn"><i class="ri-whatsapp-line"></i></a>
									</div>
									<p><b class="source">{{$t('Source')}} :</b> {{ selectedLead.entry.source }}</p>
									<p><b class="generatedOn">{{$t('GeneratedOn')}} :</b> {{ selectedLead.entry.generatedOn }}</p>
								</div>
								<div class="oml-detailsLeadLeft-actions">
									<div class="d-flex align-items-center justify-content-end">

										<multiselect 
										v-if="!$store.state.active || ($store.state.active && 'assigne' in $store.state.permissions)"  
											v-model="selectedOwner"
											@close="sendOneOwnerSelected(selectedLead.entry.id)" 
											:selected="selectedLead.entry.assigned_user_id"
											:options="owners"
											:multiple="false" 
											:show-labels="false"
											:searchable="false" 
											:allow-empty="false"
											label="title"
											track-by="id"
											class="usersSelect"
										></multiselect>
										<select class="statusUserAction" v-if="!$store.state.active || ($store.state.active && 'qualify leads' in $store.state.permissions)" :style="statusStyle" v-model="selectedLead.entry.statusId" @change="changeStatusDetails(selectedLead.entry)" :disabled="UserRole == 'viewer'">
											<template v-for="(item, key) in allStatus">
												<option :value="item.id" v-text="item.option" v-bind:key="`stKey-${key}`"></option>
											</template>
										</select>
									</div>
									<div class="d-flex align-items-center justify-content-end" v-if="selectedLead.entry.status != 'Doublon' && selectedLead.entry.status != 'Duplicate' && selectedLead.entry.is_duplicate == true">
										<button class="duplicateBtn" @click="markAsADuplicate(selectedLead.entry)">{{$t('mark_as_a_duplicate')}}</button>
									</div>
								</div>
							</div>
							<div class="oml-detailsLeadLeft-content">
								<div class="custom-tabs setting-tabs">
									<b-tabs>
										<b-tab :title="$t('lead_details')" active>
											<div class="oml-leadDetails-container">
												<div class="oml-leadDetails-item">
													<div class="oml-leadDetails-label">
														<i class="fa fa-user"></i>
														{{ $t('FirstName') }}
													</div>
													<div class="oml-leadDetails-value">
														<input type="text" :placeholder="$t('FirstName')" v-model="selectedLead.entry.personal_first_name" @blur="changeDetailsLead('personal_first_name','',selectedLead.entry.personal_first_name)" :disabled="$store.state.active && !('edit leads' in $store.state.permissions)">
													</div>
												</div>
												<div class="oml-leadDetails-item">
													<div class="oml-leadDetails-label">
														<i class="fa fa-user"></i>
														{{ $t('LastName') }}
													</div>
													<div class="oml-leadDetails-value">
														<input type="text" :placeholder="$t('LastName')" v-model="selectedLead.entry.personal_last_name" @blur="changeDetailsLead('personal_last_name','',selectedLead.entry.personal_last_name)" :disabled="$store.state.active && !('edit leads' in $store.state.permissions)">
													</div>
												</div>
												<div class="oml-leadDetails-item">
													<div class="oml-leadDetails-label">
														<i class="icon icon-phone-square"></i>
														{{ $t('Phone') }}
													</div>
													<div class="oml-leadDetails-value d-flex flex-column align-items-end">
														<input type="text" :placeholder="$t('Phone')" v-model="selectedLead.entry.personal_phone" @blur="changeDetailsLead('personal_phone','',selectedLead.entry.personal_phone)" :disabled="$store.state.active && !('edit leads' in $store.state.permissions)">
														<small v-if="selectedLead.entry.phone_verified == 0 && selectedLead.entry.personal_phone != ''" class="small-md text-secondary"><i class="fa fa-info-circle"></i> </small>
														<small v-else-if="(selectedLead.entry.phone_verified == 1 || selectedLead.entry.phone_verified == 3 ) && selectedLead.entry.personal_phone != ''" class="small-md text-danger d-flex align-items-center"><i class="ri-close-line lh-19 fs-18 mr-1"></i>{{ $t('NotValid') }}</small>
														<small v-else-if="selectedLead.entry.phone_verified == 2 && selectedLead.entry.personal_phone != ''" class="small-md text-success"><i class="fa fa-check-square-o fs-13 mr-1"></i>{{ $t('Valid') }}</small>
													</div>
												</div>
												<div class="oml-leadDetails-item">
													<div class="oml-leadDetails-label">
														<i class="fa fa-envelope"></i>
														{{ $t('Email') }}
													</div>
													<div class="oml-leadDetails-value d-flex flex-column align-items-end">
														<input type="text" :placeholder="$t('Email')" v-model="selectedLead.entry.email" @blur="changeDetailsLead('email','',selectedLead.entry.email)" :disabled="$store.state.active && !('edit leads' in $store.state.permissions)">
														<small v-if="selectedLead.entry.email_verified == 0 && selectedLead.entry.email != ''" class="small-md text-secondary"><i class="fa fa-info-circle"></i></small>
														<small v-else-if="(selectedLead.entry.email_verified == 1 || selectedLead.entry.email_verified == 3) && selectedLead.entry.email != ''" class="small-md text-danger d-flex align-items-center"><i class="ri-close-line lh-19 fs-18 mr-1"></i>{{ $t('NotValid') }}</small>
														<small v-else-if="selectedLead.entry.email_verified == 2 && selectedLead.entry.email != ''" class="small-md text-success"><i class="fa fa-check-square-o fs-13 mr-1"></i>{{ $t('Valid') }}</small>
													</div>
												</div>
												<template v-if="selectedLead.entry.entry.length > 0">
													<div 
														:class="[item.type == 'new' ? 'oml-leadDetails-item newField' : 'oml-leadDetails-item']" 
														v-for="(item, key) in selectedLead.entry.entry" 
														v-bind:key="key"
													>
														<div class="oml-leadDetails-label" v-if="item.fieldSelected == 'custom_field' && item.name != '' && !item.type">
															<i class="fa fa-building-o"></i>
															
															{{ item.name }}
														</div>
														<div class="oml-leadDetailsLabel-textfield" v-else-if="item.fieldSelected == 'custom_field' && item.type">
															<div class="oml-leadDetails-input">
																<i class="fa fa-building-o"></i>
																
																
																<input 
																	type="text" 
																	placeholder="Enter name field" 
																	v-model="item.name"
																>
															</div>
															
														</div>
														<div class="oml-leadDetails-value" v-if="item.fieldSelected == 'custom_field' && item.value != '' && !item.type">
															<input type="text" v-if="item.name!='RDV'" placeholder="Enter value field" :value="item.value"  @blur="changeDetailsLead(item.name,'custom_field',item.value)">
															<!--datetime format="DD-MM-YYYY" v-model='dob' v-if="team_id == 104536  && item.name=='RDV'"  :value="dob"  ></datetime><button v-if="team_id == 104536  && item.name=='RDV'" @click='changeRDV(item.name)' style="
    border: 0px;
    background: #d1d1d1;
    color: #000;
    border-radius: 5px;
    margin: 10px;
    font-size: 12px;
">Enregistrer le RDV</button>
<litepie-datepicker
      v-model="dob"  v-if="team_id == 104536  && item.name=='RDV'"
    ></litepie-datepicker-->
	<date-range-picker v-if="item.name=='RDV'" ref="picker" :showWeekNumbers="false" customRangeLabel= 'Custom Range' 
							:showDropdowns="false" v-model="dob" @update="[changeRDV(item.name)]">
								<template v-slot:input="picker" style="min-width: 350px;">
									<div :title="item.value">
										<i class="fa fa-calendar d-block mr-1"></i>
										<span v-if="item.value" class="range-span d-block">{{ item.value }}</span>
										<span v-else class="label-range">{{ item.value }}</span> <!-- {{ dateRange.startDate }} - {{ dateRange.endDate }} -->
										<i class="fa fa-close init-dateRange" @click="InitDateRange" v-if="Object.keys(dateRange).length > 0"></i>
									</div>
								</template>
							</date-range-picker>
														</div>
														<div class="oml-leadDetailsValue-textfield" v-else-if="item.fieldSelected == 'custom_field' && item.type">
															
															<input 
																type="text" 
																placeholder="Enter value field" 
																v-model="item.value" 
																@blur="changeDetailsLead(item.name,'custom_field',item.value)" 
																v-if="item.fieldSelected == 'custom_field' || item.name != ''" 
																:disabled="$store.state.active && !('edit leads' in $store.state.permissions)"
															>
														</div>
													</div>
												</template>
												<div class="oml-leadDetails-actions">
													<div class="leftSide">
														<!--button 
															v-if="!$store.state.active || ($store.state.active && 'edit leads' in $store.state.permissions)"
															@click="addField()" 
															v-show="anglet_value == 'lead_detail'"
															class="addField-btn"
														-->
														<button 
															v-if="!$store.state.active || ($store.state.active && 'edit leads' in $store.state.permissions)"
															@click="addField()" 
															class="addField-btn"
														>
															<i class="ri-add-line"></i> {{ $t('AddField') }}
														</button>
														<button 
															v-if="!$store.state.active || ($store.state.active && 'edit leads' in $store.state.permissions)"
															@click="minusField(selectedLead.entry.entry)" 
															v-show="(selectedLead.entry.entry.length > 0 && countNewField > 0 && anglet_value == 'lead_detail')"
															class="minusField-btn"
														>
															<i class="ri-close-line"></i> {{ $t('MinusField') }}
														</button>
													</div>
												</div>
											</div>
										</b-tab>
										<b-tab 
											v-if="!$store.state.active || ($store.state.active && 'send email to leads' in $store.state.permissions)" 
											:title="$t('send_email')" 
											:active="!tabsFocus" 
											@click="test('send_email')"
										>
											<div class="oml-sendEmail-container">
												<div class="oml-sendEmail-content">
													<div class="oml-infos-box d-flex align-items-center">
														<i class="fa fa-info-circle fs-30 mr-3"></i>
														<p>
															{{$t('sendEmail_config_msg')}} <router-link  :to="{ path: '/account/smtp'}" target='_blank'>{{$t('config_from_here')}}</router-link>.
															
														</p>
													</div>

													<b-row class="mt-3">
														<b-col cols="6">
															<div class="form-group">
																<label>{{$t('email_lead_to')}}</label>
																<div style="display:none">{{ emailArray.to = selectedLead.entry.email }} </div>
																<input type="text" class="form-control" :placeholder="$t('email_lead_to')" v-model="emailArray.to" disabled/>
															</div>
														</b-col>
														<b-col cols="6">
															<div class="form-group">
																<label>{{$t('email_lead_from')}}</label>
																<input type="text" class="form-control" :placeholder="$t('email_lead_from')" :value="smtp.email" disabled v-if="smtp" />
																<input type="text" class="form-control" :placeholder="$t('email_lead_from')" :value="$auth.user().email" disabled  v-else />
															</div>
														</b-col>
													</b-row>

													<b-row>
														<b-col cols="6">
															<div class="form-group">
																<label>{{$t('email_lead_subject')}}</label>
																<input type="text" class="form-control" :placeholder="$t('email_lead_subject')" v-model="emailArray.Subject" />
															</div>
														</b-col>
														<b-col cols="6">
															<div class="form-group">
																<label>{{$t('Template')}}</label>
																<div class="d-flex align-items-center">
																	<select class="form-control" @change="changeTemplate" v-model="emailArray.selectedTemplate">
																		<option value="">{{$t('email_add_template')}}</option>
																		<option v-for="(item, key) in emailArray.arrayEmailTemplates" v-bind:key="key" :value="key" v-html="item.title"></option>
																	</select>
																	<router-link :to="{ path: 'settings/email-templates'}" target="_blank">
																		<button class="oml-addNewTemp ml-2">
																			<i class="ri-add-line"></i>
																		</button>
																	</router-link>
																</div>
															</div>
														</b-col>
													</b-row>

													<b-row>
														<b-col cols="12">
															<div class="form-group">
																<label>{{$t('body')}}</label>
																<vue-editor id="template_body" :editorOptions="editorOptions" ref="editorMd" v-model="emailArray.contentMessage" class="oml-vueEditor" :placeholder="$t('BodyHere')"></vue-editor>
															</div>
														</b-col>
													</b-row>

													<b-row>
														<b-col cols="12" class="d-flex align-items-center justify-content-end">
															<button class="oml-btn lightGray-btn px-4" @click="discardEmail()">{{$t('email_lead_discard')}}</button>
															<button class="oml-btn ml-2 px-4" @click="sendEmail()">{{$t('email_lead_send')}}</button>
														</b-col>
													</b-row>
												</div>
											</div>
										</b-tab>
										<b-tab 
											title="Calendly" 
										>
											<div class="oml-calendly-container">
												<section class="ac-containeer">
													<div class="" v-if="url">
														<iframe :src="url" width="100%" height="400" name="search_iframe"></iframe>
													</div>
													<div v-else>
														<div class="oml-calendly-noResult">
															<img src="/img/no-calendly.png">
															<p>{{$t('calendlyNoResult')}}</p>
															<button class="oml-btn green-btn" @click="ChangeRoute('integrations')">{{$t('Configure')}}</button>
														</div>
													</div>
												</section>
											</div>
										</b-tab>
										
									</b-tabs>
								</div>
							</div>
						</div>
						<div class="oml-detailsLeadBody-right">
								<div class="custom-tabs setting-tabs">
									<b-tabs>
										<b-tab :title="$t('activities')">
											<div class="oml-activities-container">
												<div class="oml-activities-content">
													<div class="oml-activities-body">
														<div class="oml-activities-actLine">
														
															<div class="oml-actLine-item light-yellow" v-for="(element, key) in selectedLead.entry.notes" v-bind:key="`notes-${key}`">
																<div class="oml-actLineItem-icon">
																	<i class="icon icon-note"></i>
																</div>
																<div class="oml-actLineItem-content">
																	<p class="header"><b>{{ $t('at') }}</b> {{ element.created_at }} <b>{{ $t('by') }}</b> <span v-b-tooltip.hover.topLeft v-b-tooltip="{customClass: 'activities-tooltip'}" :title="element.user.name">{{ element.user.name }}</span></p>
																	<p v-if="element.content != 'email_sent'">{{ element.content }}</p>
																	<!--p v-if="element.content != 'email_sent'" class="d-flex align-items-start">
																		<span class="substr ml-2" v-if="element.content.length > 24 && showMoreNote == -1" v-html="element.content"></span>
																		<span class="ml-2" v-else-if="element.content.length < 24 && showMoreNote == -1" v-html="element.content"></span>
																		<span class="ml-2" v-else-if="element.content.length < 24 && showMoreNote == key" v-html="element.content"></span>
																		<span class="ml-2" v-else-if="element.content.length > 24 && showMoreNote == key" v-html="element.content"></span>
																	</p-->
																	<!--p v-else>{{ $t(element.content) }}</p-->

																	<p v-else class="d-flex align-items-start">
																		<span class="substr ml-2" v-if="element.content.length > 24 && showMoreNote == -1" v-html="element.content"></span>
																		<span class="ml-2" v-else-if="element.content.length < 24 && showMoreNote == -1" v-html="element.content"></span>
																		<span class="ml-2" v-else-if="element.content.length < 24 && showMoreNote == key" v-html="element.content"></span>
																		<span class="ml-2" v-else-if="element.content.length > 24 && showMoreNote == key" v-html="element.content"></span>
																	</p>

																	<button class="span" v-if="element.content.length > 24 && showMoreNote == -1" @click="showMoreNote = key">Show more</button>
																	<button class="span" v-if="showMoreNote == key" @click="showMoreNote = -1">Show less</button>
																</div>
															</div>
															<div class="oml-actLine-item light-blue" v-for="(element, key) in selectedLead.entry.historic" v-bind:key="`${key}-${element.id}`">
																<div class="oml-actLineItem-icon">
																	<i class="icon icon-tag" v-if="element.action.id == 2 && element.currentColor != '' && element.currentColor != null"></i>
																	<i class="icon icon-person" v-else></i>
																</div>
																<div class="oml-actLineItem-content">
																	<p class="header"><b>{{ $t('at') }}</b> {{ element.created_at }} <b>{{ $t('by') }}</b> <span v-b-tooltip.hover.topLeft v-b-tooltip="{customClass: 'activities-tooltip'}" :title="element.user.name">{{ element.user.name }}</span></p>
																	
																	<p v-if="element.action.libelle != null">{{ element.action.libelle }}</p>

																	<p v-if="element.action.id == 1">{{ element.contenuactions }}</p>

																	<div class="oml-actLineItem-values d-flex align-items-center" v-else-if="element.action.id == 2">
																		<template v-if="element.currentColor != '' && element.currentColor != null">
																			<p><b>{{ $t('From') }}:</b> <span :style="{color:element.currentColor}">{{ element.firstactions | maxLength }}</span></p>
																			<p class="ml-3"><b>{{ $t('to') }}:</b><span :style="{color:element.previousColor}">{{ element.lastactions | maxLength }}</span></p>
																		</template>
																		<template v-else>
																			<p><b>{{ $t('From') }}:</b> <span v-b-tooltip.hover.topLeft v-b-tooltip="{customClass: 'activities-tooltip'}" :title="element.firstactions">{{ element.firstactions | maxLength }}</span></p>
																			<p class="ml-3"><b>{{ $t('to') }}:</b> <span v-b-tooltip.hover.topLeft v-b-tooltip="{customClass: 'activities-tooltip'}" :title="element.lastactions">{{ element.lastactions | maxLength }}</span></p>
																		</template>
																	</div>
																	<template v-else-if="element.action.id == 4">
																		<div class="oml-actLineItem-values d-flex align-items-center" v-if="element.entry.newemail != ''">
																			<p><b>{{ $t('From') }}:</b><span v-b-tooltip.hover.topLeft v-b-tooltip="{customClass: 'activities-tooltip'}" :title="element.entry.oldemail">{{ element.entry.oldemail | maxLength }}</span></p>
																			<p class="ml-3"><b>{{ $t('to') }}:</b> <span v-b-tooltip.hover.topLeft v-b-tooltip="{customClass: 'activities-tooltip'}" :title="element.entry.newemail">{{ element.entry.newemail | maxLength }}</span></p>
																		</div>
																		<div class="oml-actLineItem-values d-flex align-items-center" v-if="element.entry.newpersonalphone != ''">
																			<p><b>{{ $t('From') }}:</b><span v-b-tooltip.hover.topLeft v-b-tooltip="{customClass: 'activities-tooltip'}" :title="element.entry.oldpersonalphone">{{ element.entry.oldpersonalphone | maxLength }}</span></p>
																			<p class="ml-3"><b>{{ $t('to') }}:</b> <span v-b-tooltip.hover.topLeft v-b-tooltip="{customClass: 'activities-tooltip'}" :title="element.entry.newpersonalphone">{{ element.entry.newpersonalphone | maxLength }}</span></p>
																		</div>
																		<div class="oml-actLineItem-values d-flex align-items-center" v-if="element.entry.newpersonalfirstname != ''">
																			<p><b>{{ $t('From') }}:</b><span v-b-tooltip.hover.topLeft v-b-tooltip="{customClass: 'activities-tooltip'}" :title="element.entry.oldpersonalfirstname">{{ element.entry.oldpersonalfirstname | maxLength }}</span></p>
																			<p class="ml-3"><b>{{ $t('to') }}:</b><span v-b-tooltip.hover.topLeft v-b-tooltip="{customClass: 'activities-tooltip'}" :title="element.entry.newpersonalfirstname">{{ element.entry.newpersonalfirstname | maxLength }}</span></p>
																		</div>
																		<div class="oml-actLineItem-values d-flex align-items-center" v-if="element.entry.newpersonallastname != ''">
																			<p><b>{{ $t('From') }}:</b><span v-b-tooltip.hover.topLeft v-b-tooltip="{customClass: 'activities-tooltip'}" :title="element.entry.oldpersonallastname">{{ element.entry.oldpersonallastname | maxLength }}</span></p>
																			<p class="ml-3"><b>{{ $t('to') }}:</b><span v-b-tooltip.hover.topLeft v-b-tooltip="{customClass: 'activities-tooltip'}" :title="element.entry.newpersonallastname">{{ element.entry.newpersonallastname | maxLength }}</span></p>
																		</div>
																	</template>
																</div>
															</div>
															<div class="oml-actLine-item light-green" v-for="(assign, index) in selectedLead.entry.assigned_action" v-bind:key="`${index}-${assign.id}`">
																<div class="oml-actLineItem-icon">
																	<i class="icon icon-group fs-23"></i>
																</div>
																<div class="oml-actLineItem-content">
																	<p class="header"><b>{{ $t('at') }}</b> {{ assign.created_at }} <b>{{ $t('by') }}</b> <span v-b-tooltip.hover.topLeft v-b-tooltip="{customClass: 'activities-tooltip'}" :title="assign.user.name">{{ assign.user.name }}</span></p>
																	<div class="oml-actLineItem-values d-flex align-items-center">
																		<p><b>{{ $t('From') }}:</b><template v-if="assign.assigned_from"><span v-b-tooltip.hover.topLeft v-b-tooltip="{customClass: 'activities-tooltip'}" :title="assign.assigned_from.name">{{assign.assigned_from.name | maxLength}}</span></template><template><span v-b-tooltip.hover.topLeft v-b-tooltip="{customClass: 'activities-tooltip'}" title="Unassigned">Unassigned</span></template></p>
																		<p class="ml-3"><b>{{ $t('to') }}:</b><template v-if="assign.assigned_to"><span v-b-tooltip.hover.topLeft v-b-tooltip="{customClass: 'activities-tooltip'}" :title="assign.assigned_to.name">{{assign.assigned_to.name | maxLength}}</span></template></p>
																	</div>
																</div>
															</div>

															<div class="oml-actLine-item email-box" v-for="(email, key) in selectedLead.entry.email_historiques" v-bind:key="`${key}-${email.id}`">
																<div class="oml-actLineItem-icon">
																	<i class="icon icon-mail"></i>
																</div>
																<div class="oml-actLineItem-content d-block">
																	<p class="header"><b> {{ $t('at') }}</b> {{email.created_at}}<b> {{ $t('by') }} </b> <span v-b-tooltip.hover.topLeft v-b-tooltip="{customClass: 'activities-tooltip'}" :title="email.user.name">{{email.user.name | maxLength}}</span></p>
																	<p><b>{{$t('EmailSentTo')}} :</b> {{email.to}}</p>
																	<p><b>{{$t('Subject')}} :</b> {{email.subject}}</p>
																	<p class="d-flex align-items-start">
																		<b>{{$t('Body')}} :</b>
																		<span class="substr ml-2" v-if="email.body.length > 24 && email.seeMore == false" v-html="email.body"></span>
																		<span class="ml-2" v-else-if="email.body.length < 24 && email.seeMore == false" v-html="email.body"></span>
																		<span class="ml-2" v-else-if="email.body.length < 24 && email.seeMore == true" v-html="email.body"></span>
																		<span class="ml-2" v-else-if="email.body.length > 24 && email.seeMore == true" v-html="email.body"></span>
																	</p>
																	<button class="span" v-if="email.body.length > 24 && email.seeMore == false" @click="email.seeMore = !email.seeMore">{{$t('ShowMore')}}</button>
																	<button class="span" v-if="email.seeMore == true" @click="email.seeMore = !email.seeMore">Show less</button>
																</div>
															</div>

															<div class="oml-actLine-item light-blue">
																<div class="oml-actLineItem-icon">
																	<i class="icon icon-enter fs-23"></i>
																</div>
																<div class="oml-actLineItem-content">
																	<p class="header"><b>{{ $t('at') }}</b> {{ selectedLead.entry.generatedOn }} <b>{{ $t('by') }}</b> <span v-b-tooltip.hover v-b-tooltip="{customClass: 'activities-tooltip'}" :title="$auth.user().name">{{ $auth.user().name }}</span></p>
																	<p>{{ $t('NewLeadReceived') }}</p>
																</div>
															</div>


															<!--div class="oml-actLine-item light-blue">
																<div class="oml-actLineItem-icon">
																	<i class="ri-medal-2-line"></i>
																</div>
																<div class="oml-actLineItem-content">
																	<p class="header"><b>At</b> 10/09/2021 12:00:00</p>
																	<p>New lead received</p>
																</div>
															</div>
															<div class="oml-actLine-item light-blue">
																<div class="oml-actLineItem-icon">
																	<i class="ri-medal-2-line"></i>
																</div>
																<div class="oml-actLineItem-content">
																	<p class="header"><b>At</b> 10/09/2021 12:00:00 <b>by</b> Mehdi MOURABIT</p>
																	<div class="d-flex align-items-center">
																		<p><b>From</b> : <span class="color-red">Unqualified</span></p>
																		<p class="ml-3"><b>To</b> : <span class="color-blue">Pending</span></p>
																	</div>
																</div>
															</div>
															<div class="oml-actLine-item light-yellow">
																<div class="oml-actLineItem-icon">
																	<i class="ri-medal-2-line"></i>
																</div>
																<div class="oml-actLineItem-content">
																	<p class="header"><b>At</b> 10/09/2021 12:00:00 <b>by</b> Mehdi MOURABIT</p>
																	<p><b>Email sent to :</b> contact@webeuz.com</p>
																	<p><b>Subject :</b> Hello</p>
																	<p><b>Body :</b> Le Lorem Ipsum est simplement du faux texte employé dans la composition et la mis.</p>
																	<a href="#">See more</a>
																</div>
															</div>
															<div class="oml-actLine-item light-blue">
																<div class="oml-actLineItem-icon">
																	<i class="ri-medal-2-line"></i>
																</div>
																<div class="oml-actLineItem-content">
																	<p class="header"><b>At</b> 10/09/2021 12:00:00 <b>by</b> Mehdi MOURABIT</p>
																	<div class="d-flex align-items-center">
																		<p><b>From</b> : Taoufik</p>
																		<p class="ml-3"><b>To</b> : Taoufik</p>
																	</div>
																</div>
															</div>
															<div class="oml-actLine-item light-yellow">
																<div class="oml-actLineItem-icon">
																	<i class="ri-medal-2-line"></i>
																</div>
																<div class="oml-actLineItem-content">
																	<p class="header"><b>At</b> 10/09/2021 12:00:00</p>
																	<p>New lead received</p>
																</div>
															</div>
															<div class="oml-actLine-item light-green">
																<div class="oml-actLineItem-icon">
																	<i class="ri-medal-2-line"></i>
																</div>
																<div class="oml-actLineItem-content">
																	<p class="header"><b>At</b> 10/09/2021 12:00:00</p>
																	<p>New lead received</p>
																</div>
															</div>
															<div class="oml-actLine-item light-blue">
																<div class="oml-actLineItem-icon">
																	<i class="ri-medal-2-line"></i>
																</div>
																<div class="oml-actLineItem-content">
																	<p class="header"><b>At</b> 10/09/2021 12:00:00</p>
																	<p>New lead received</p>
																</div>
															</div>
															<div class="oml-actLine-item light-blue">
																<div class="oml-actLineItem-icon">
																	<i class="ri-medal-2-line"></i>
																</div>
																<div class="oml-actLineItem-content">
																	<p class="header"><b>At</b> 10/09/2021 12:00:00</p>
																	<p>New lead received</p>
																</div>
															</div>
															<div class="oml-actLine-item light-yellow">
																<div class="oml-actLineItem-icon">
																	<i class="ri-medal-2-line"></i>
																</div>
																<div class="oml-actLineItem-content">
																	<p class="header"><b>At</b> 10/09/2021 12:00:00</p>
																	<p>New lead received</p>
																</div>
															</div>
															<div class="oml-actLine-item light-green">
																<div class="oml-actLineItem-icon">
																	<i class="ri-medal-2-line"></i>
																</div>
																<div class="oml-actLineItem-content">
																	<p class="header"><b>At</b> 10/09/2021 12:00:00</p>
																	<p>New lead received</p>
																</div>
															</div>
															<div class="oml-actLine-item light-blue">
																<div class="oml-actLineItem-icon">
																	<i class="ri-medal-2-line"></i>
																</div>
																<div class="oml-actLineItem-content">
																	<p class="header"><b>At</b> 10/09/2021 12:00:00</p>
																	<p>New lead received</p>
																</div>
															</div-->
														</div>
													</div>
													<div class="oml-activities-footer" v-if="!$store.state.active || ($store.state.active && 'add note to leads' in $store.state.permissions)">
														<textarea 
															name="" 
															id="" 
															cols="30" 
															rows="3" 
															v-model="textareaNote" 
															:disabled="UserRole == 'viewer'"
															:placeholder="$t('WriteNoteLead')"
														></textarea>
														<button :class="[textareaNote != '' ? '' : 'disabled']" :disabled="textareaNote != '' ? false : true" @click="addNoteEvent">{{ $t('AddNote') }}</button>
													</div>
												</div>
											</div>
										</b-tab>
										<b-tab v-if="selectedLead.entry.is_duplicate === 1">
											<template #title>
												<div class="d-flex align-items-center justify-content-center">
													{{ $t('duplicates') }}<span class="oml-countDup-title">{{selectedLead.entry.duplicates_leads.length}}</span>
												</div>
											</template>

											<div class="oml-tabDuplicate-container">
												<div class="oml-tabDuplicate-content">
													<div class="oml-tabDuplicate-item" v-for="(duplicatedLead,id) in selectedLead.entry.duplicates_leads" :key="duplicatedLead.id">
														<div class="oml-tabDuplicateItem-header d-flex align-items-center justify-content-between">
															<h3 class="mb-0" v-if="duplicatedLead.personal_first_name != ''">{{duplicatedLead.personal_first_name}} {{duplicatedLead.personal_last_name}}</h3>
															<h3 class="mb-0" v-else>{{duplicatedLead.full_name}}</h3>
															<div class="oml-tabDuplicateItem-time">{{duplicatedLead.duration}}</div>
														</div>
														<div class="oml-tabDuplicateItem-content">
															<div class="oml-tabDuplicateItem-infos">
																<p>{{duplicatedLead.email}}</p>
																<p>{{duplicatedLead.personal_phone}}</p>
																<p v-if="duplicatedLead.status"><b>Status:</b> {{duplicatedLead.status}}</p>
																<p><b>{{$t('Source')}} :</b> {{duplicatedLead.source}}</p>
																<p><b>{{ $t('GeneratedOn')}} :</b> {{duplicatedLead.generatedOn}}</p>
															</div>
															<div class="oml-tabDuplicateItem-view">
																<button @click="myLeadDetail(duplicatedLead,id,'view')"><i class="ri-eye-line mr-0"></i></button>
															</div>
														</div>
													</div>
												</div>
											</div>
										</b-tab>
									</b-tabs>
								</div>
							</div>



							<template v-if="doCall"> <!-- v-if="doCall" -->
									<div :class="[showCallDetails ? 'bv-callDetails' : 'bv-callDetails withoutDetails']">
										<div class="bv-callDetails-container">
											<div class="bv-callDetails-content">
												<div class="bv-callDetails-hiddenDetails" v-if="!showCallDetails">
													<div class="bv-callDetails-header">
														<div class="d-flex align-items-center">
															<h4>Call in progress...</h4>
															<div class="call-timer">
																<span>00:23</span>
															</div>
														</div>

														<div class="bv-callDetailsHeader-actions">
															<button class="hangUp-btn"><i class="ri-phone-fill"></i></button>
															<button class="" @click="showCallDetails = !showCallDetails"><i class="ri-fullscreen-line"></i></button>
															<button @click="doCall = false"><i class="ri-close-fill"></i></button>
														</div>
													</div>
												</div>
												<div class="bv-callDetails-moreDetails" v-if="showCallDetails">
													<div class="bv-callDetails-header">
														<h3>Device</h3>

														<div class="bv-callDetailsHeader-actions">
															<button class=""  @click="showCallDetails = !showCallDetails"><i class="ri-fullscreen-exit-fill"></i></button>
															<button @click="doCall = false"><i class="ri-close-fill"></i></button>
														</div>
													</div>
													<div class="bv-callDetails-deviceStep1" v-if="connectStep1">
														<div class="bv-callDetailsStep1-img">
															<svg xmlns="http://www.w3.org/2000/svg" width="59.619" height="70.956" viewBox="0 0 59.619 70.956">
																<path id="technical-support-line" d="M74.042,4.831a1.6,1.6,0,0,1,.182-2.254l2.583-2.2a1.6,1.6,0,0,1,2.072,2.436L76.3,5.013a1.6,1.6,0,0,1-2.254-.182Zm4.65,6.765a1.6,1.6,0,0,0-.021,3.2l3.391.028h.011a1.6,1.6,0,0,0,.011-3.206ZM76.664,8.607a1.6,1.6,0,0,0,2.049.956l5.618-2.045a1.6,1.6,0,1,0-1.094-3L77.62,6.558A1.6,1.6,0,0,0,76.664,8.607Zm-11.47,50.6a9.473,9.473,0,0,1-1.114,2.813c-1.534,2.657-3.393,3.819-4.877,3.062l-2.346-1.048a13.6,13.6,0,0,1-2.9,1.677l-.265,2.547c-.079,1.669-2.014,2.7-5.09,2.7s-5-1.029-5.09-2.694l-.265-2.554a13.594,13.594,0,0,1-2.9-1.677L38,65.077c-1.484.766-3.345-.395-4.883-3.058s-1.611-4.851-.211-5.756l2.07-1.5a13.844,13.844,0,0,1,0-3.366l-2.07-1.5c-1.4-.907-1.32-3.1.214-5.754s3.4-3.824,4.883-3.058l2.316,1.035a13.59,13.59,0,0,1,2.929-1.7L43.51,37.9c.087-1.663,2.022-2.692,5.09-2.692s5.011,1.032,5.09,2.7l.261,2.517a13.593,13.593,0,0,1,2.929,1.7L59.2,41.083c1.484-.759,3.344.4,4.878,3.061a9.468,9.468,0,0,1,1.114,2.813c.345,1.788-.376,2.6-.9,2.943l-2.066,1.5a13.854,13.854,0,0,1,0,3.367l2.07,1.5C64.818,56.607,65.539,57.418,65.194,59.206Zm-5.641-9.822,2.5-1.814A7.283,7.283,0,0,0,60.1,44.183l-2.817,1.259a1.6,1.6,0,0,1-1.712-.262,10.455,10.455,0,0,0-3.618-2.1,1.6,1.6,0,0,1-1.081-1.35l-.318-3.063a7.282,7.282,0,0,0-3.911,0l-.317,3.062a1.6,1.6,0,0,1-1.081,1.351,10.461,10.461,0,0,0-3.619,2.1,1.6,1.6,0,0,1-1.712.262L37.1,44.183a7.285,7.285,0,0,0-1.955,3.387l2.5,1.814a1.6,1.6,0,0,1,.63,1.608,10.635,10.635,0,0,0,0,4.172,1.6,1.6,0,0,1-.629,1.611l-2.509,1.818A7.282,7.282,0,0,0,37.1,61.98l2.839-1.269a1.6,1.6,0,0,1,1.709.26,10.461,10.461,0,0,0,3.6,2.078,1.6,1.6,0,0,1,1.081,1.35l.321,3.092a7.281,7.281,0,0,0,3.911,0l.321-3.092a1.6,1.6,0,0,1,1.081-1.35,10.459,10.459,0,0,0,3.6-2.078,1.6,1.6,0,0,1,1.709-.26L60.1,61.98a7.282,7.282,0,0,0,1.955-3.387l-2.509-1.817a1.6,1.6,0,0,1-.629-1.611,10.641,10.641,0,0,0,0-4.173A1.6,1.6,0,0,1,59.553,49.383Zm-4.87,3.682A6.083,6.083,0,1,1,48.6,46.983,6.09,6.09,0,0,1,54.682,53.065Zm-3.2,0A2.885,2.885,0,1,0,48.6,55.951,2.889,2.889,0,0,0,51.485,53.065Zm39.829,9.717L86.182,48.764a1.636,1.636,0,0,0-.087-.2,3.516,3.516,0,0,0-2.807-2.093c-.779-.1-1.544-.139-2.284-.18-.363-.02-.727-.04-1.091-.067a18.451,18.451,0,0,1-3.3-.511,7.638,7.638,0,0,1-4.264-2.41c-1.69-2.049-4.356-9.331-4.389-11.987a7.637,7.637,0,0,1,1.7-4.593A17.97,17.97,0,0,1,71.85,24.2c.258-.253.521-.5.784-.749.479-.453.975-.92,1.451-1.423A3.519,3.519,0,0,0,75,18.221L69.867,4.2A3.545,3.545,0,0,0,65.326,2.1l-3.548,1.3a11.332,11.332,0,0,0-2.534,1.193c-6.4,3.9-9.9,11.474-9.874,21.319a45.532,45.532,0,0,0,.357,5.463,1.6,1.6,0,1,0,3.173-.395,42.319,42.319,0,0,1-.332-5.078c-.025-8.684,2.938-15.283,8.341-18.58A8.249,8.249,0,0,1,62.871,6.4l3.553-1.3a.343.343,0,0,1,.44.2L72,19.32a.342.342,0,0,1-.094.374c-.036.032-.07.065-.1.1-.425.452-.88.881-1.361,1.335-.277.261-.554.523-.826.79a21.315,21.315,0,0,0-2.567,2.963,10.743,10.743,0,0,0-2.286,6.477c.042,3.393,2.96,11.364,5.119,13.982a10.743,10.743,0,0,0,5.928,3.471,21.56,21.56,0,0,0,3.874.605c.383.028.765.049,1.148.071.718.04,1.4.077,2.071.161a.335.335,0,0,1,.274.219q.027.075.061.145l5.078,13.869a.343.343,0,0,1-.2.44L84.88,65.5a10.1,10.1,0,0,1-2.885.75c-4.355.539-8.695-.816-12.9-4.027a1.6,1.6,0,0,0-1.941,2.541,21.482,21.482,0,0,0,13.029,4.8,17.893,17.893,0,0,0,2.2-.136,13.166,13.166,0,0,0,3.592-.921l3.227-1.181A3.545,3.545,0,0,0,91.314,62.782Z" transform="translate(-31.911 0)" fill="#1fabec"/>
															</svg>
														</div>
														<p>In order to use this feature, please connect your Favorite Voip account and start dialing right away!</p>
														<button class="connect-btn" @click="[connectStep1 = false, connectStep2 = true]">Connect</button>
														<div class="or-txt">Or</div>
														<a href="#">Call using your default App</a>
													</div>
													<div class="bv-callDetails-deviceStep2" v-if="connectStep2">
														<div class="bv-callDetailsStep2-img">
															<svg xmlns="http://www.w3.org/2000/svg" width="107.625" height="146.877" viewBox="0 0 107.625 146.877">
																<g id="Groupe_5126" data-name="Groupe 5126" transform="translate(-26.256 -14.874)">
																	<path id="Tracé_717" data-name="Tracé 717" d="M123.107,232.973s-36.721,3.362-46.9-8.231c0,0,37.913-20.606,54.351,7,0,0,12.855,3.782,10.26,19.64,0,0-2.853-4.007-7-3.533S123.107,232.973,123.107,232.973Z" transform="translate(-23.245 -202.479)" fill="#e69962"/>
																	<path id="Tracé_718" data-name="Tracé 718" d="M136.4,270.544c0,16.358-14.17,30.531-33.27,30.531s-34.586-13.257-34.586-29.613c0-42.792,14.824-43.8,33.927-43.8S136.4,232.092,136.4,270.544Z" transform="translate(-23.06 -202.728)" fill="#ffe5ba"/>
																	<path id="Tracé_719" data-name="Tracé 719" d="M75.021,279.488a4.733,4.733,0,1,1-4.731-4.733A4.74,4.74,0,0,1,75.021,279.488Z" transform="translate(-22.988 -203.863)" fill="#ffe5ba"/>
																	<path id="Tracé_720" data-name="Tracé 720" d="M132.706,279.488a4.737,4.737,0,1,0,4.737-4.733A4.74,4.74,0,0,0,132.706,279.488Z" transform="translate(-24.607 -203.863)" fill="#ffe5ba"/>
																	<rect id="Rectangle_373" data-name="Rectangle 373" width="10.326" height="15.086" transform="translate(74.247 97.01)" fill="#ffe5ba"/>
																	<path id="Tracé_721" data-name="Tracé 721" d="M104.863,222.893c-25.113-2.8-31.762,6.732-33.445,17.178,0,0,3.721,8.459,31.41,8.459s30.1-8.459,30.1-8.459C127.474,226.5,113.316,223.839,104.863,222.893Z" transform="translate(-23.13 -202.601)" fill="#e69962"/>
																	<path id="Tracé_722" data-name="Tracé 722" d="M130.357,232.634S104.035,213.064,69,227.314c0,0,18.493,9.149,23.844,8.145S131.5,232.6,130.357,232.634Z" transform="translate(-23.072 -202.594)" fill="#e69962"/>
																	<path id="Tracé_723" data-name="Tracé 723" d="M137.481,274.225s7.381-29.537-3.172-33.72c-1.8-.715-5.422,4.263-5.422,4.263S128.474,256.5,137.481,274.225Z" transform="translate(-24.515 -203.036)" fill="#e69962"/>
																	<path id="Tracé_724" data-name="Tracé 724" d="M68.658,274.212s-7.5-30.067,3.047-34.25c1.8-.714,5.551,4.793,5.551,4.793S77.67,256.487,68.658,274.212Z" transform="translate(-23.001 -203.023)" fill="#e69962"/>
																	<path id="Tracé_725" data-name="Tracé 725" d="M76.051,242.845a15.816,15.816,0,0,1-9.979-8.564,117.077,117.077,0,0,1,14.774-6.625C86.86,225.317,76.051,242.845,76.051,242.845Z" transform="translate(-23.001 -202.723)" fill="#e69962"/>
																	<path id="Tracé_726" data-name="Tracé 726" d="M129.919,241.159c-3.535,4.276-47.225,10.3-62.723-5.828,0,0,36.018,8.661,57.807,2.4C129.457,236.448,132.117,238.5,129.919,241.159Z" transform="translate(-23.028 -202.913)" fill="#ebad81"/>
																	<g id="Groupe_5113" data-name="Groupe 5113" transform="translate(78.966 110.988)">
																		<path id="Tracé_727" data-name="Tracé 727" d="M151.107,323.155c-.941-.9-20.5-7.313-20.5-7.313-4.378,4.432-27.755,1.662-27.755,1.662v.107c.7-.03,1.1-.055,1.1-.055l0,49.048h0a81.566,81.566,0,0,0,53.81-20.183C156.763,336.295,154.837,326.74,151.107,323.155Z" transform="translate(-102.854 -315.842)" fill="#406187"/>
																	</g>
																	<g id="Groupe_5114" data-name="Groupe 5114" transform="translate(26.256 110.988)">
																		<path id="Tracé_728" data-name="Tracé 728" d="M55.5,323.155c.941-.9,20.5-7.313,20.5-7.313,4.379,4.432,27.755,1.662,27.755,1.662v.107c-.7-.03-1.1-.055-1.1-.055l0,49.048h0a81.573,81.573,0,0,1-53.813-20.183C49.849,336.295,51.777,326.74,55.5,323.155Z" transform="translate(-48.842 -315.842)" fill="#406187"/>
																	</g>
																	<path id="Tracé_729" data-name="Tracé 729" d="M103.652,345.015s-9.362.446-10,0-3.584-14.893-3.511-17.134.678-9.738,3.511-9.738,23.943-5.6,26.822-1.121S113.506,350.724,103.652,345.015Z" transform="translate(-23.581 -204.84)" fill="#ededed"/>
																	<path id="Tracé_730" data-name="Tracé 730" d="M103.82,315.842v11.2h-2.988a38.238,38.238,0,0,1-3.731-7.912S100.162,316.14,103.82,315.842Z" transform="translate(-23.749 -204.854)" fill="#3b2525"/>
																	<path id="Tracé_731" data-name="Tracé 731" d="M103.986,315.842v11.2h2.982a38.187,38.187,0,0,0,3.735-7.912S107.642,316.14,103.986,315.842Z" transform="translate(-23.915 -204.854)" fill="#4f3131"/>
																	<path id="Tracé_732" data-name="Tracé 732" d="M97.668,307.288l-14.173,5.856,10.818,12.642,9.179-10.15A9.492,9.492,0,0,1,97.668,307.288Z" transform="translate(-23.421 -204.647)" fill="#fff"/>
																	<path id="Tracé_733" data-name="Tracé 733" d="M108.488,307.4l15.5,5.746-10.891,12.642-9.107-10.15S108.432,313.718,108.488,307.4Z" transform="translate(-23.915 -204.65)" fill="#fff"/>
																	<g id="Groupe_5115" data-name="Groupe 5115" transform="translate(73.352 122.185)">
																		<path id="Tracé_734" data-name="Tracé 734" d="M100.832,327.315c-3.118,9.107-3.731,24.26-3.731,24.26l6.719,12.613V327.315Z" transform="translate(-97.101 -327.315)" fill="#3b2525"/>
																		<path id="Tracé_735" data-name="Tracé 735" d="M106.968,327.315h-2.982v36.873l7.862-12.121S111.471,338.5,106.968,327.315Z" transform="translate(-97.267 -327.315)" fill="#4f3131"/>
																	</g>
																	<path id="Tracé_736" data-name="Tracé 736" d="M118.64,311.259l12,4.473-6.653,10.151,4.2,6.046-24.2,31.873Z" transform="translate(-23.915 -204.743)" fill="#7088a5"/>
																	<path id="Tracé_737" data-name="Tracé 737" d="M88.022,311.294l-12,4.473,6.652,10.152-4.2,6.046,24.2,31.872Z" transform="translate(-23.241 -204.744)" fill="#7088a5"/>
																	<g id="Groupe_5121" data-name="Groupe 5121" transform="translate(53.826 54.803)">
																		<path id="Tracé_738" data-name="Tracé 738" d="M96.2,267.825a3.566,3.566,0,1,1-3.566-3.572A3.566,3.566,0,0,1,96.2,267.825Z" transform="translate(-77.382 -258.413)" fill="#525355"/>
																		<path id="Tracé_739" data-name="Tracé 739" d="M94.563,267a1.478,1.478,0,1,1-1.474-1.479A1.479,1.479,0,0,1,94.563,267Z" transform="translate(-77.443 -258.444)" fill="#f1f2f2"/>
																		<path id="Tracé_740" data-name="Tracé 740" d="M111.683,267.825a3.567,3.567,0,1,0,3.568-3.572A3.567,3.567,0,0,0,111.683,267.825Z" transform="translate(-77.927 -258.413)" fill="#525355"/>
																		<path id="Tracé_741" data-name="Tracé 741" d="M113.417,267a1.48,1.48,0,1,0,1.485-1.479A1.484,1.484,0,0,0,113.417,267Z" transform="translate(-77.969 -258.444)" fill="#f1f2f2"/>
																		<g id="Groupe_5116" data-name="Groupe 5116" transform="translate(6.487)">
																			<path id="Tracé_742" data-name="Tracé 742" d="M91.417,258.269c-3.357,0-6.232,1.164-7.677,2.846a17.95,17.95,0,0,1,7.677-1.979,16.9,16.9,0,0,1,7.679,1.979C97.65,259.433,94.773,258.269,91.417,258.269Z" transform="translate(-83.74 -258.269)" fill="#525355"/>
																		</g>
																		<g id="Groupe_5117" data-name="Groupe 5117" transform="translate(30.734)">
																			<path id="Tracé_743" data-name="Tracé 743" d="M116.271,258.269c3.349,0,6.228,1.164,7.675,2.846a17.975,17.975,0,0,0-7.675-1.979,16.915,16.915,0,0,0-7.685,1.979C110.04,259.433,112.911,258.269,116.271,258.269Z" transform="translate(-108.586 -258.269)" fill="#525355"/>
																		</g>
																		<g id="Groupe_5118" data-name="Groupe 5118" transform="translate(0 14.178)">
																			<path id="Tracé_744" data-name="Tracé 744" d="M82.271,277.206a.966.966,0,1,1-.966-1.017A.992.992,0,0,1,82.271,277.206Z" transform="translate(-77.171 -272.879)" fill="#fdcd85"/>
																			<path id="Tracé_745" data-name="Tracé 745" d="M79.082,280.1a.684.684,0,1,1-.681-.722A.7.7,0,0,1,79.082,280.1Z" transform="translate(-77.108 -272.956)" fill="#fdcd85"/>
																			<path id="Tracé_746" data-name="Tracé 746" d="M79.783,273.921a.684.684,0,1,1-.684-.719A.7.7,0,0,1,79.783,273.921Z" transform="translate(-77.125 -272.807)" fill="#fdcd85"/>
																			<path id="Tracé_747" data-name="Tracé 747" d="M85.468,274.659a.687.687,0,1,1-.685-.72A.7.7,0,0,1,85.468,274.659Z" transform="translate(-77.262 -272.825)" fill="#fdcd85"/>
																			<path id="Tracé_748" data-name="Tracé 748" d="M84.442,280.1a.686.686,0,1,1-.685-.722A.7.7,0,0,1,84.442,280.1Z" transform="translate(-77.237 -272.956)" fill="#fdcd85"/>
																			<path id="Tracé_749" data-name="Tracé 749" d="M82.739,273.248a.431.431,0,1,1-.43-.451A.438.438,0,0,1,82.739,273.248Z" transform="translate(-77.208 -272.797)" fill="#fdcd85"/>
																			<path id="Tracé_750" data-name="Tracé 750" d="M77.956,276.756a.438.438,0,0,1-.431.453.455.455,0,0,1,0-.909A.439.439,0,0,1,77.956,276.756Z" transform="translate(-77.093 -272.881)" fill="#fdcd85"/>
																			<path id="Tracé_751" data-name="Tracé 751" d="M81.2,281.31a.429.429,0,1,1-.428-.456A.439.439,0,0,1,81.2,281.31Z" transform="translate(-77.171 -272.991)" fill="#fdcd85"/>
																			<path id="Tracé_752" data-name="Tracé 752" d="M85.655,277.681a.428.428,0,1,1-.429-.45A.441.441,0,0,1,85.655,277.681Z" transform="translate(-77.279 -272.904)" fill="#fdcd85"/>
																		</g>
																		<g id="Groupe_5119" data-name="Groupe 5119" transform="translate(43.644 15.494)">
																			<path id="Tracé_753" data-name="Tracé 753" d="M125.18,278.555a.966.966,0,1,0,.963-1.021A.991.991,0,0,0,125.18,278.555Z" transform="translate(-121.896 -274.228)" fill="#fdcd85"/>
																			<path id="Tracé_754" data-name="Tracé 754" d="M128.379,281.445a.686.686,0,1,0,.685-.721A.7.7,0,0,0,128.379,281.445Z" transform="translate(-121.973 -274.305)" fill="#fdcd85"/>
																			<path id="Tracé_755" data-name="Tracé 755" d="M127.674,275.269a.687.687,0,1,0,.688-.719A.7.7,0,0,0,127.674,275.269Z" transform="translate(-121.956 -274.156)" fill="#fdcd85"/>
																			<path id="Tracé_756" data-name="Tracé 756" d="M121.994,276.006a.686.686,0,1,0,.686-.719A.7.7,0,0,0,121.994,276.006Z" transform="translate(-121.819 -274.173)" fill="#fdcd85"/>
																			<path id="Tracé_757" data-name="Tracé 757" d="M123.019,281.445a.687.687,0,1,0,.689-.721A.7.7,0,0,0,123.019,281.445Z" transform="translate(-121.844 -274.305)" fill="#fdcd85"/>
																			<path id="Tracé_758" data-name="Tracé 758" d="M124.734,274.6a.433.433,0,1,0,.435-.451A.441.441,0,0,0,124.734,274.6Z" transform="translate(-121.885 -274.146)" fill="#fdcd85"/>
																			<path id="Tracé_759" data-name="Tracé 759" d="M129.521,278.1a.43.43,0,1,0,.43-.455A.44.44,0,0,0,129.521,278.1Z" transform="translate(-122.001 -274.23)" fill="#fdcd85"/>
																			<path id="Tracé_760" data-name="Tracé 760" d="M126.275,282.658a.431.431,0,1,0,.429-.455A.442.442,0,0,0,126.275,282.658Z" transform="translate(-121.923 -274.34)" fill="#fdcd85"/>
																			<path id="Tracé_761" data-name="Tracé 761" d="M121.815,279.031a.431.431,0,1,0,.428-.451A.441.441,0,0,0,121.815,279.031Z" transform="translate(-121.815 -274.253)" fill="#fdcd85"/>
																		</g>
																		<g id="Groupe_5120" data-name="Groupe 5120" transform="translate(8.688 21.043)">
																			<path id="Tracé_762" data-name="Tracé 762" d="M103.725,285.109v2.007s10.47.664,16.609-5.274A41.255,41.255,0,0,1,103.725,285.109Z" transform="translate(-86.423 -279.88)" fill="#dab289"/>
																			<path id="Tracé_763" data-name="Tracé 763" d="M103.315,285.109v2.007s-10.465.664-16.6-5.274A41.173,41.173,0,0,0,103.315,285.109Z" transform="translate(-86.013 -279.88)" fill="#dab289"/>
																			<path id="Tracé_764" data-name="Tracé 764" d="M103.725,290.3v2.043s7.314,0,9.623-3.264A52.1,52.1,0,0,1,103.725,290.3Z" transform="translate(-86.423 -280.055)" fill="#dab289"/>
																			<path id="Tracé_765" data-name="Tracé 765" d="M103.488,290.3v2.043s-7.309,0-9.614-3.264A51.962,51.962,0,0,0,103.488,290.3Z" transform="translate(-86.185 -280.055)" fill="#dab289"/>
																			<path id="Tracé_766" data-name="Tracé 766" d="M118.229,280.831c1.308,1.17,2,.813,3.152,4.116,0,0,.142-3.631-2.112-4.892C118.025,279.355,117.85,280.493,118.229,280.831Z" transform="translate(-86.768 -279.832)" fill="#dab289"/>
																			<path id="Tracé_767" data-name="Tracé 767" d="M89.141,280.831c-1.3,1.17-2,.813-3.144,4.116,0,0-.143-3.631,2.107-4.892C89.341,279.355,89.513,280.493,89.141,280.831Z" transform="translate(-85.995 -279.832)" fill="#dab289"/>
																		</g>
																	</g>
																	<g id="Groupe_5125" data-name="Groupe 5125" transform="translate(36.141 17.492)">
																		<g id="Groupe_5122" data-name="Groupe 5122" transform="translate(71.145 40.486)">
																			<path id="Tracé_768" data-name="Tracé 768" d="M146.648,273.75a12.227,12.227,0,0,0-9.788-11.978v23.955A12.225,12.225,0,0,0,146.648,273.75Z" transform="translate(-131.993 -261.528)" fill="#379bc2"/>
																			<path id="Tracé_769" data-name="Tracé 769" d="M134.308,261.522a12.358,12.358,0,0,0-2.435.244v23.955a12.258,12.258,0,0,0,4.867,0V261.766A12.321,12.321,0,0,0,134.308,261.522Z" transform="translate(-131.873 -261.522)" fill="#297492"/>
																		</g>
																		<g id="Groupe_5123" data-name="Groupe 5123" transform="translate(0 40.486)">
																			<path id="Tracé_770" data-name="Tracé 770" d="M58.971,273.75a12.226,12.226,0,0,1,9.789-11.978v23.955A12.225,12.225,0,0,1,58.971,273.75Z" transform="translate(-58.971 -261.528)" fill="#379bc2"/>
																			<path id="Tracé_771" data-name="Tracé 771" d="M71.434,261.522a12.381,12.381,0,0,1,2.435.244v23.955a12.258,12.258,0,0,1-4.867,0V261.766A12.306,12.306,0,0,1,71.434,261.522Z" transform="translate(-59.213 -261.522)" fill="#297492"/>
																		</g>
																		<path id="Tracé_772" data-name="Tracé 772" d="M109.532,298.059v-2.928c24.362,0,28.214-16.324,28.366-17.019l2.862.612C140.72,278.919,136.349,298.059,109.532,298.059Z" transform="translate(-60.19 -221.436)" fill="#379bc2"/>
																		<path id="Tracé_773" data-name="Tracé 773" d="M113.439,296.961a3.691,3.691,0,0,1-3.69,3.69h-6.342a3.691,3.691,0,0,1-3.691-3.69h0a3.69,3.69,0,0,1,3.691-3.69h6.342a3.689,3.689,0,0,1,3.69,3.69Z" transform="translate(-59.953 -221.801)" fill="#297492"/>
																		<g id="Groupe_5124" data-name="Groupe 5124" transform="translate(5.199)">
																			<path id="Tracé_774" data-name="Tracé 774" d="M64.365,269.9,64.3,259.22c0-21.61,16.913-39.184,37.7-39.184s37.7,17.574,37.7,39.174a40.7,40.7,0,0,1-1.4,10.575l-2.826-.761a37.8,37.8,0,0,0,1.3-9.814c0-19.986-15.6-36.247-34.775-36.247s-34.774,16.26-34.774,36.247l.067,10.668Z" transform="translate(-64.298 -220.036)" fill="#379bc2"/>
																		</g>
																	</g>
																</g>
															</svg>
														</div>
														<div class="call-timer" v-if="toHang">
															<span>00:23</span>
														</div>
														<div class="bv-input">
															<input type="text" value="2126000000">
														</div>
														<button
															class="connect-btn"
															@click="[toCall = false, toRing = true, toRingContent = true]"
															v-if="toCall"
														>
															<div class="d-flex align-items-center">
																<i class="ri-phone-line"></i> Call
															</div>
														</button>
														<button
															class="connect-btn"
															@click="[toCall = false, toRing = false, toHang = true]"
															v-if="toRing"
														>
															<div class="d-flex align-items-center">
																<i class="ri-phone-line"></i> Ringing
															</div>
														</button>
														<button
															class="connect-btn hang-up"
															@click="[toCall = true, toRing = false, toHang = false, toRingContent = false]"
															v-if="toHang"
														>
															<div class="d-flex align-items-center">
																<i class="ri-phone-line"></i> HANG UP
															</div>
														</button>
														<div :class="[toHang ? 'toRing-content hang-up' : 'toRing-content']" v-if="toRingContent">
															<h4>Mic Volume</h4>
															<b-progress value="30" max="90" variant="#1FABEC" class="mb-3"></b-progress>
															<h4 class="mt-3">Speaker Volume</h4>
															<b-progress value="30" max="90" variant="#1FABEC" class="mb-3"></b-progress>
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
								</template>
						</div>
					</div>
				</div>
			</div>
			
		
			
		
			
		
		
			
		</div>
</template>
<!--script src="https://cdn.jsdelivr.net/npm/vue/dist/vue.js"></script-->
<script>
	//import dataTable from '@/plugins/md/dataTable/datatable-myleads.vue';
	//import multiSelect from '@/plugins/md/multiselect/select-dropdown.vue';
	import moment from 'moment'

	// Basic Use - Covers most scenarios
	
	/* Send Mail */
	import { VueEditor } from "vue2-editor";
	
	import XLSX from 'xlsx';
	import Pusher from 'pusher-js';
	
	//import DateRangePicker from 'vue2-daterange-picker'
	import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'


	//import Multiselect from 'vue-multiselect'
	//import detailsLead from './details-lead/detailsLead'
	//import datetime from 'vuejs-datetimepicker';

	export default {
		components: {
			//dataTable,
			VueEditor,
			//multiSelect,
			//DateRangePicker
			//Multiselect
			//detailsLead
		},
		data() {
			return {
				payementStatut: "",
				ColumnBlur		: 0,
				optionsSelectSource: {
					selectAll	: true,
					defaultSelected: ''
				},
				
				customFields: [
					{ field: "personal_gender", data: ""},
					{ field: "personal_title", data: ""},
					{ field: "personal_birthday", data: ""},
					{ field: "personal_website", data: ""},
					{ field: "personal_address1", data: ""},
					{ field: "personal_address2", data: ""},
					{ field: "personal_street", data: ""},
					{ field: "personal_house_number", data: ""},
					{ field: "personal_mobile", data: ""},
					{ field: "personal_fax", data: ""},
					{ field: "personal_postal", data: ""},
					{ field: "personal_city", data: ""},
					{ field: "personal_state", data: ""},
					{ field: "personal_country", data: ""},
					{ field: "personal_impressum", data: ""},
					
					{ field: "custom_field", data: ""},
					
				],
				dob : {},
				loadingDeleteLead: false,
				loadingSaveChanges: false,
				textareaNote: '',
				searchCount	: 0,
				
				statusStyle : {backgroundColor: '#00bbf6', borderColor: '#00bbf6'},
				
				validateField	: {
					full_name: false, personal_first_name: false, personal_last_name: false, personal_phone: false, email: false, status: false
				},
				tabsFocus		: true,
				loadingData		: false,
				
				/* Email */
				emailArray: {
					Subject			: "",
					contentMessage	: "",
					selectedTemplate: "",
					from:'',
					to:'',
					arrayEmailTemplates: [],
				},
				/* Email */
				
				/* add new field */
				
				arrayFieldsAddLead	: [],
				/* add new field */
				
				/* customToolbar */
				customToolbar: [
					/* ["blockquote", "code-block"], */
					[{ header: [6, 5, 4, 3, 2, 1, false] }],
					["bold", "italic"],
					[ { list: "ordered" }, { list: "bullet" }/* , { list: "check" } */],
					[ { align: "" }, { align: "center" }, { align: "right" }, { align: "justify" } ],
					//[{ 'align': [] }],

					//[{ indent: "-1" }, { indent: "+1" }],
					//[{ color: ['#000000', '#663d00', '#f5523c', '#377dff', '#ccc', '#ffc107', '#28a745'] }, { background: [] }], // dropdown with defaults from theme
					//[{ 'font': [] }],
					// ["link", "image", "video"], 
					//["clean"] // remove formatting button
				],
				/* customToolbar */
				
				processing	: false,
				moreData	: false,
				
				gridColumns	: [
					{ title:  this.$t('Name')		   , column: 'full_name'  , enable: true},
					{ title: this.$t('Status')	   , column: 'status'	  , enable: true},
					{ title: this.$t('Email')	   , column: 'email'	  , enable: true},
					{ title: this.$t('Phone')	   , column: 'personal_phone', enable: true},
					{ title: this.$t('GeneratedOn'), column: 'generatedOn', enable: true},
					{ title: this.$t('Source')	   , column: 'source'	  , enable: false},
					// { title: 'Details'	   , column: 'details'	  , enable: true}
				],
				
				gridData: [],
				current_page: 1,
				last_page	: 6,
				totalLead	: 0,
				selectedLead : {
					"id": 0,
					"entry": { 
						"id"				: 0,
						"full_name"			: "",
						"personal_first_name": '',
						"personal_last_name": '',
						"status"			: "",
						"score"				: '',
						"email"				: "",
						"personal_phone"	: "",
						"generatedOn"		: "",
						"source"			: '',
						"color"				: "",
						"entry"				: [],
						"email_verified"	: "",
						"phone_verified"	: "",
						"details"			: "",
						"assigned_action"   : [],
						"assigned_user_id"  : "",
						"email_historiques"   : [],
					}
				},
				
				newLead: {
					full_name: '', personal_first_name: '', personal_last_name: '', personal_phone: '', email: '', status: ''
				},
				
				mySources : [],
				myStatus  : [],
				owners    : [],
				selectedOwner:[],
				selectedOwnerFicheLead:[],
				allStatus : [],
				/*Filters	  : [
					{ id: 'email_valid', title: this.$t('EmailValid') },
					{ id: 'phone_valid', title: this.$t('PhoneValid') },
					{ id: 'duplicate', title: this.$t('duplicate') },
				],*/
				Filters	  : [],
				itemIds	  : [],
				
				leadGetter: true,
				
				tableSearch: {
					searchQuery		: '',
					selectedSources	: [],
					selectedStatus	: [],
					selectedFilter	: [],
					selectedOwners	: [],
					assigned_user_id: [],
				},
				dateRange			: {},
				leadEnrichmensList  : [],
				dataEnrichmens		: {status: false, name:'',loading:false},
				
				showHideDetail	: false,
				
				countNewField	: 0,
				DemoDataPanel	: false,
				demoDataPanelSeen : true,
				loadingAction	: false,
				
				ProcDemoData	: false,
				ProcPanel		: false,
				
				SourceScore		: 0,	
				PercentArray	: { emails: 0, phones: 0, duplicate: 0 },
				VariantArray	: { emails: 'secondary', phones: 'secondary', duplicate: 'secondary' },
				srcInterval		: '',
				UserRole		: '',
				doCall          :false,
				dispatcher:false,
                connectStep1    :true,
                connectStep2    :false,
                toCall          :true,
                toRing          :false,
                toRingContent   :false,
                toHang          :false,
                showCallDetails :true,
                duplicates_leads:[],
                visible_collapse_1: true,
                visible_collapse_2: false,
                editorOptions: {
					modules: {
						toolbar: {
							container: [
								[{'placeholder': ['[[prospect_first_name]]','[[prospect_last_name]]','[[prospect_full_name]]', '[[prospect_phone]]', '[[prospect_email]]']}],
								[{'size': ['small', false, 'large', 'huge']}],
								[{'font': []}],
								['bold', 'italic', 'underline', 'link', {'color': []}],
								[{'list': 'ordered'}, {'list': 'bullet'}, {'indent': '-1'}, {'indent': '+1'}],
								[{'direction': 'rtl'}],
								[{'align': []}],
								['clean']
							],
							handlers: {
								"placeholder": function (value) {
									if (value) {
										const cursorPosition = this.quill.getSelection().index;
										this.quill.insertText(cursorPosition, value);
										this.quill.setSelection(cursorPosition + value.length);
									}
								}
							}
						}
					}
                },
                anglet_value : 'lead_detail',
                smtp: {},
                userInfo: {},

				smartview:{
					id:0,
					name:'',
				},

				activeDetailsLead:false,
				deleteSendToBtn:false,
				leadOwnerSelected:null,
				bulkSendTo:{
					client_id: null,
					worspace_id: null,
					lead_id:[]
				},
				bulkOwners:{
					client_id: null,
					assignedTo: null,
					leads:[]
				},
				showMoreNote:-1,
				url: {
					'name'  : '',
					'email' : '',
				},
				filterClicked:false,
				showSaveView:false,
				inputFilterSearch:false,
				detailsExist:false,
				customColumns:false,
				team_id  : JSON.parse(localStorage.getItem('oml-client')).id
			}
		},
		
		methods: {
			moment: function () {
					return moment();
				},
			changeRDV(name) {
				var dateD =  moment(this.dob.startDate).format('MM - DD -YYYY');
				var dateF =  moment(this.dob.endDate).format('MM - DD -YYYY');
				if(dateD != dateF){
					this.changeDetailsLead('entry',name,dateD + '-' + dateF )
				}else{
					this.changeDetailsLead('entry',name,dateD )
				}
				
				},
			GetPayemetStatut() {
				this.payementStatut = this.$route.params.status;
				if (this.payementStatut) {
					this.$bvModal.show("bv-modal-payement-status");
				}
			},
			ClosePayementModal() {
				this.$bvModal.hide("bv-modal-payement-status");
			},
			showDspatcher() {
				this.dispatcher = true;
				
			},
			GetTeamRole() {
				let that = this
				
				let url   = '/teammember/teamMembers'
				let method= 'POST'
				let data  = {}
				
				let UserCheck = JSON.parse( localStorage.getItem('oml-user') )
				
				that.$store.dispatch('apiRequest', { url, method, data } ).then((response) => {
					// that.arrayMembers = []
					let members = response.data.members

					/*that.owners.push({ title: 'Unassigned', id:0, enable: false})
					response.data.members.forEach( function(item) {
						that.owners.push({ title: item.name, id: item.id, enable: false})
					})
					that.owners.forEach( function(item) {
						that.tableSearch.assigned_user_id.push(item.id)
					})*/
					//that.owners.push({ title: item.name, column: item.type + '_' + item.libelle, enable: false })
					// console.log(members)
					members.forEach( function(member) {
						if( UserCheck.id == member.id ) {
							that.UserRole = member.role
						}
						// that.arrayMembers.push({id: member.id, name: member.name, email: member.email, role: member.role, role_id: member.role_id})
					} )
				}).catch(() => {
					
				})
				
			},
			
			ShowHideCols(col) {
				let that = this
				col.enable = !col.enable
				
				let SelectedCols = []
				that.gridColumns.forEach( function( item ) {
					if( item.enable ) {
						SelectedCols.push(item.column)
					}
				} )
				localStorage.setItem('selected-cols', JSON.stringify(SelectedCols) )
				
			},
			
			SourceStats(action) {
				let that = this
				if( action == 'show' ) {
					that.ProcPanel = false
					that.$bvModal.show('bv-modal-state')
					
					setTimeout( function() {
						that.arcMove('round', that.SourceScore)
					}, 400 )
					
				} else {
					that.ProcPanel = true
					that.$bvModal.hide('bv-modal-state')
				}
			},
			CheckSourceStats() {
				let that  = this
				
				let url   = 'myleads_info'
				let method= 'GET'
				let data  = {}
				
				that.ProcPanel = true
				clearInterval(that.srcInterval)
				that.srcInterval = setInterval (function() {
					
					that.$store.dispatch( 'apiRequest', { url, method, data } ).then((response) => {
						
						if( response.data.success ) {
							
							that.ProcDemoData	= true
							that.ProcPanel		= true
							let emails 		= response.data.emails
							let phones 		= response.data.phones
							let duplicate 	= response.data.duplicate
							that.PercentArray.emails 	= emails
							that.PercentArray.phones 	= phones
							that.PercentArray.duplicate = duplicate
							that.SourceScore			= response.data.score
							
							that.VariantArray.emails	= (emails < 10) ? 	 'danger'  : (emails < 60) ?  	'warning' : 'success'
							that.VariantArray.phones	= (phones < 10) ? 	 'danger'  : (phones < 60) ?  	'warning' : 'success'
							that.VariantArray.duplicate	= (duplicate == 0) ? 'success' : (duplicate < 3) ?  'warning' : 'danger'
							
							clearInterval(that.srcInterval)
							
							that.SourceStats('show')
							
							
						}
					}).catch(() => {
						clearInterval(that.srcInterval)
					})
					
				}, 15000);
				
			},
			
			CheckDemoData() {
				let that  = this
				
				let url   = 'newsource_info'
				let method= 'GET'
				let data  = {}
				that.$store.dispatch( 'apiRequest', { url, method, data } ).then((response) => {
					that.leftSidebarInfo()
					that.DemoDataPanel = ( response.data.demoData && response.data.leadsCount > 0 )
					that.demoDataPanelSeen = response.data.modal_displayed
					if(response.data.modal_displayed && ( response.data.demoData && response.data.leadsCount > 0 )) {
						that.CheckSourceStats()
					}
				}).catch(() => {
					
				})
			},
			
			ClearDemoData() {
				let that  = this
				
				that.loadingAction = true
				
				let url		= 'sources/delete_source/demo_data'
				let method	= 'DELETE'
				let data	= {provider : "delete sources", permissionid : 3}
				
				that.$store.dispatch('apiRequest', { url, method, data } ).then((response) => {
					
					let feedback = response.data
					if(feedback.success) {
						that.leftSidebarInfo()
						that.notifyMe(this.$t('ChangesSaved'), 'success')
						that.loadingAction = false
						that.$bvModal.hide('modal-delete-source');
						// window.location.href = '/myleads'
						that.$router.push( { path: '/newsource' } )
						
					}
					
				}).catch(( {response} ) => {
					that.notifyMe(response.data.message, 'warn')
					that.loadingAction = false
				})
				
			},
			
			notifyMe(message, variant){
				this.$notify({
					group	: 'foo',
					// title: 'Important message',
					text	: message,
					type	: variant,
					// duration: 500000,
					// speed	: 1000
				});
			},
			InitDateRange () {
				let that = this
				that.dateRange = {}
				that.getLeads(true, 'filter')
			},
			ModalAddLead() {
				let that = this
				that.newLead.full_name = ''
				that.newLead.personal_first_name = ''
				that.newLead.personal_last_name = ''
				that.newLead.personal_phone = ''
				that.newLead.email = ''
              //that.newLead.status = ''
                that.getDefaultStatus()
				that.$bvModal.show('bv-modal-addLead')
			},
			targetOpen(link) {
				window.open(link, "_blank")
			},
			closeModalLeadDetails() {
				let that = this;
				that.countNewField = 0;
				that.getLeads(true,'filter')
				that.setCollapseParams();
				that.$bvModal.hide('bv-modal-leadDetails');
				that.leadEnrichmensList = [];
				that.discardEmail();
				that.anglet_value = 'lead_detail';
			},
			changeDetailsLead(action, field = '', value = '') {
					
				if(value != ''){
					let that = this
					if(field == 'RDV'){
						Object.keys(that.selectedLead.entry.entry).forEach(key => {
							if(that.selectedLead.entry.entry[key].name=="RDV"){
								
								that.selectedLead.entry.entry[key].value = value;
								
							}
							
					
						});
					}
					console.log(that.selectedLead.entry.entry)
					that.selectedLead.entry.action = (field == 'custom_field') ? 'entry' : action
					
					let url   = 'leads/update_lead'
					let method= 'PATCH'
					let data  = that.selectedLead.entry
					console.log(data);
					data.provider = "edit leads"
					that.$store.dispatch('apiRequest', { url, method, data } ).then((response) => {
						if( action != field && response.data.success ) {
							that.notifyMe(this.$t('ChangesSaved'), 'success')
							that.gridData[ that.selectedLead.id ].historic = response.data.historiques
							that.selectedLead.entry.historic = response.data.historiques
							if( action == 'email' || action == 'personal_phone' ) {
								that.selectedLead.entry.email_verified = response.data.emailCheck
								that.selectedLead.entry.phone_verified = response.data.phoneCheck
							}
						}
					}).catch(( {response} ) => {
						console.log(response)
					})
				} else {
					//alert('changeDetailsLead')
				}
			},
			minusField(entry) {
				let that = this;
				if(that.countNewField > 0) {
					entry.splice(-1,1);
					that.changeDetailsLead('custom_field','custom_field','aaaaaa');
					that.countNewField--;
				}
			},
			addField() {
				
				this.countNewField++;
				//this.newFieldsIndexes.push(this.selectedLead.entry.entry.length)
				this.selectedLead.entry.entry.push( { name: '', value: '', fieldSelected:'custom_field', type:'new' } )
			},
			
			addNoteEvent() {
				let that = this
				if( that.textareaNote != '' ) {
					that.loadingSaveChanges = true
					
					let url   = 'leads/save_note'
					let method= 'POST'
					let data  = {selectedLead: that.selectedLead.entry.id, textareaNote:that.textareaNote, provider : "add note to leads", permissionid : 14}
					
					that.$store.dispatch('apiRequest', { url, method, data } ).then((response) => {
						
						that.gridData[ that.selectedLead.id ].historic = response.data.historiques
						that.gridData[ that.selectedLead.id ].notes = response.data.notes
						that.selectedLead.entry.historic = response.data.historiques
						that.selectedLead.entry.notes = response.data.notes
						that.loadingSaveChanges = false
						
						that.notifyMe(this.$t('noteAdded'), 'success')
						
						that.textareaNote = ''
						
					}).catch(( {response} ) => {
						that.notifyMe(response.data.message, 'warn')
					})
					
				} else {
					that.notifyMe(this.$t('fieldNotRequired'), 'warn')
				}
			},
			changeStatusDetails(entry) {
				let that = this
				that.allStatus.forEach( function(item) {
					if ( item.id == entry.statusId  ) {
						that.statusStyle.backgroundColor = item.color
						that.statusStyle.borderColor	 = item.color
						entry.status = item.title
						that.gridData[ that.selectedLead.id ].status = item.title
						that.gridData[ that.selectedLead.id ].color  = item.color
					}
				})
				let url   = 'leads/change_status'
				let method= 'PATCH'
				let data  = {leadId: entry.id, newStatus: entry.statusId, provider : "edit status", permissionid : 21}
				
				that.$store.dispatch('apiRequest', { url, method, data } ).then((response) => {
					if( response.data.success ) {
						if( response.data.message) {
							//let myMessage = response.data.message
							//that.notifyMe(myMessage,'success')
							that.notifyMe(this.$t('statusChanged'), 'success')
						}
						if( response.data.sent ) {
							that.notifyMe(this.$t('statusChanged'), 'success')
						}
						that.gridData[ that.selectedLead.id ].historic = response.data.historiques
						that.selectedLead.entry.historic = response.data.historiques
						that.gridData[ that.selectedLead.id ].notes = response.data.notes
						that.selectedLead.entry.notes = response.data.notes
						that.$store.state.reloadLeftSidebarCompenent = Math.random();
						that.$store.state.checkChange = true;
						that.getLeads(true, 'filter')
					}	
				}).catch(( {response} ) => {
					console.log(response)
				})
			},
			
			updateValue (value) {
				value = value.hex
				return value.hex
			},
			
			downloadFile(dataArray) {
				let that  = this
				var today = new Date();
				var dd 	  = String(today.getDate()).padStart(2, '0');
				var mm 	  = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
				var yyyy  = today.getFullYear();
				
				today = mm + '-' + dd + '-' + yyyy;
				
				const data = XLSX.utils.json_to_sheet(dataArray)
				const wb = XLSX.utils.book_new()
				XLSX.utils.book_append_sheet(wb, data, 'data')
				XLSX.writeFile(wb,'myLeads-('+today+')-file.' + 'csv') // csv - xlsx
				that.processing = false
			},
			
			bulkActions(action) {
				
				let that = this
				if( action == 'sendSms' ) {
					that.$bvModal.show('bv-modal-sendSms')
					// this.totalLead
				} else if ( action == 'Export' ) {
					
					let dataArray = []
					that.processing = true
					if( that.itemIds.length != 0 ) {
						
						that.gridData.forEach( function(val) {
							
							let idLead = parseInt(val.id);
							
							if ( that.itemIds.includes( idLead ) ) {
								
								let arDt = [], field = ''
								that.gridColumns.forEach( function(item) {
									if( /* item.enable && */ item.column != 'id' && item.column != 'details' ) {
										// field = item.column
										// arDt[field] = val[field] != null ? val[field] : ''
										field = item.column.replace('custom_', '')
										arDt[field] = val[item.column] != null ? val[item.column] : ''
									}
								} )
								let notes = val.notes != null ? val.notes : [], title = (arDt['notes'] != '' && arDt['notes'] != null) ? 'lead notes' : 'notes'
								arDt[title] = ''
								notes.forEach( function(note) {
									arDt[title] += '- ' + note.content + "\n"
								} )
								dataArray.push(arDt)
							}
						} )
						that.downloadFile(dataArray)
						that.processing = false
					} else {
						
						that.loadingData = true
						that.processing = true
						
						let method= 'POST'
						let data  = { 
							searchQuery:that.tableSearch.searchQuery,
							selectedSources:that.tableSearch.selectedSources,
							selectedStatus:that.tableSearch.selectedStatus,
							selectedFilter:that.tableSearch.selectedFilter,
							dateRange:that.dateRange
						}
						let url   = 'leads'
						
						that.$store.dispatch('apiRequest', { url, method, data } ).then((response) => {
							
							let myLeads = response.data.leads
							myLeads.forEach( function(val) {
								
								let arDt = [], field = ''
								that.gridColumns.forEach( function(item) {
									if( /* item.enable && */ item.column != 'id' && item.column != 'details' ) {
										if ( item.column == 'status' ) {
											arDt[item.column] = val.param.state
										} else if ( item.column == 'generatedOn' ) {
											arDt[item.column] = val.created_at
										} else if ( item.column == 'source' ) {
											arDt[item.column] = val.source.name
										} else {
											if( item.column.match(/custom_/) ) {
												field = item.column.replace('custom_', '')
												arDt[field] = val.entry[field] != null ? val.entry[field] : ''
											} else {
												field = item.column
												arDt[field] = val[field] != null ? val[field] : ''
											}
										}
									}
								} )
								let notes = val.notes != null ? val.notes : [], title = (arDt['notes'] != '' && arDt['notes'] != null) ? 'lead notes' : 'notes'
								arDt[title] = ''
								notes.forEach( function(note) {
									arDt[title] += '- ' + note.content + "\n"
								} )
								if(val.entry.RDV){
arDt['RDV'] = val.entry.RDV;
								}
								
								dataArray.push(arDt)
								
							} )
							
							that.loadingData = false
							that.processing = false
							that.downloadFile(dataArray)
							
						}).catch(( response ) => {
							console.log(response) 
							that.loadingData = false
							that.processing = false
						})
						
					}
					
				} else {
					that.BulkChangeStatus(action)
				}
				
			},
			
			BulkChangeStatus(action) {
				let that  = this
				let url   = 'leads/bulk_status'
				let method= 'POST'
				let data  = { leads:that.itemIds, action:action, provider : "qualify leads", permissionid : 13}
				that.loadingDeleteLead = true
				that.$store.dispatch('apiRequest', { url, method, data } ).then((response) => {
					if( response.data.success ) {
						if( response.data.sent ) {
							let message = that.itemIds.length > 1 ? this.$t('leadsHaveBeenSent') : this.$t('leadHasBeenSent')
							that.notifyMe(message, 'success')
						} else {
							that.notifyMe(this.$t('statusChanged'), 'success')
						}
					}
					
					that.getLeads(true, 'filter')
					that.leftSidebarInfo()
					that.$bvModal.hide('delete-leads')
					that.loadingDeleteLead = false
				}).catch(( /* {response} */ ) => {
					that.loadingDeleteLead = false
				})
			},
			
			confirmDeleteLead() {
				let that = this
				that.loadingDeleteLead = true

				let url   = 'leads/delete_lead/' + that.selectedLead.entry.id
				let method= 'DELETE'
				let data  = {provider : "delete leads", permissionid : 19}
				
				that.$store.dispatch('apiRequest', { url, method, data } ).then((response) => {
					if ( response.data.success ) {
						that.notifyMe(this.$t('leadDeleted'), 'success')
						that.loadingDeleteLead = false
						that.leftSidebarInfo()
						that.$bvModal.hide('modal-delete-lead')
						that.getLeads(true, 'filter')
						that.activeDetailsLead = false
					}
				}).catch(( {response} ) => {
					// console.log(response)
					that.loadingDeleteLead = false
					that.notifyMe(response.data.message, 'warn')
				})
			},
			confirmDeleteLeads(leads) {
				let that = this
				that.loadingDeleteLead = true

				leads.forEach(function(item) {
					
					let url   = 'leads/delete_lead/' + item
					let method= 'DELETE'
					let data  = {provider : "delete leads", permissionid : 19}
					
					that.$store.dispatch('apiRequest', { url, method, data } ).then((response) => {
						if ( response.data.success ) {
							that.loadingDeleteLead = false
							that.leftSidebarInfo()
							that.$bvModal.hide('modal-delete-leads')
							that.getLeads(true, 'filter')
							let messageDelete = that.$t('leadsDeleted')
							that.notifyMe(messageDelete, 'success')
							
						}
					}).catch(( {response} ) => {
						// console.log(response)
						that.loadingDeleteLead = false
						that.notifyMe(response.data.message, 'warn')
					})
				})
				
			},
			switchLeads(action) {
				let that = this
				if( action == 'next' ) {
					if( that.gridData.length < that.selectedLead.id + 5 && !that.loadingData ) {
						that.getLeads(true,'')
					}
					that.selectedLead.id    = that.selectedLead.id + 1

					// to Centralize alter
					that.countNewField = 0;
					that.gridData[that.selectedLead.id].entry.forEach(function(item) {
						if(item.type && item.type == 'new') {
							that.countNewField = that.countNewField + 1;
						}
					});
					
					// to Centralize alter
				} else {
					that.selectedLead.id = that.selectedLead.id - 1

					// to Centralize alter
					that.countNewField = 0;
					console.log(that.gridData[that.selectedLead.id]);
					that.gridData[that.selectedLead.id].entry.forEach(function(item) {
						if(item.type && item.type == 'new') {
							that.countNewField = that.countNewField + 1;
						}
					});
					// to Centralize alter
					
					
				}	

				/* Lead duplicate */
				let url    = 'lead_details'
				let method = 'GET'
				let data   = {'lead_id':that.gridData[that.selectedLead.id].id}
				that.duplicates_leads = [];
				that.$store.dispatch('apiRequest', {url, method, data }).then((response) => {
					if(response.data.success == true) {
						var duplicatesLeads = response.data.duplicatesLeads;
						duplicatesLeads.forEach( function(duplicates_lead) {
							let duplicateLeadEntry = Object.keys( duplicates_lead.entry ), arrayDLEntry = [], entryDLValues = Object.values( duplicates_lead.entry )
							if ( duplicateLeadEntry.length > 0 ) {
								duplicateLeadEntry.forEach( function(item, key) {
									arrayDLEntry.push( { name: item, value: entryDLValues[key], fieldSelected: "custom_field" } )
								});
							}
							var date1 = new Date()
							var date = new Date(duplicates_lead.created_at)
							var duration_2 = that.duration(date1,date)
							that.duplicates_leads.push({
								id : duplicates_lead.id,
								full_name: (duplicates_lead.full_name == null || duplicates_lead.full_name == '') ? duplicates_lead.personal_first_name + ' ' + duplicates_lead.personal_last_name : duplicates_lead.full_name,
								personal_first_name		: duplicates_lead.personal_first_name == null ? '' : duplicates_lead.personal_first_name,
								personal_last_name		: duplicates_lead.personal_last_name == null ? '' : duplicates_lead.personal_last_name,
								status					: duplicates_lead.param.state,
								score					: duplicates_lead.scoring,
								email					: duplicates_lead.email == null ? '' : duplicates_lead.email,
								personal_phone			: duplicates_lead.personal_phone == null ? '' : duplicates_lead.personal_phone,
								generatedOn				: duplicates_lead.created_at,
								updated_at				: duplicates_lead.updated_at,
								source					: duplicates_lead.source.name,
								color					: duplicates_lead.param.color,
								statusId				: duplicates_lead.param.id,
								historic				: duplicates_lead.historiques,
								notes					: duplicates_lead.notes,
								email_verified			: duplicates_lead.email_verified,
								phone_verified			: duplicates_lead.phone_verified,
								enabled					: duplicates_lead.enabled,
								is_duplicate	        : duplicates_lead.is_duplicate,
								entry					: arrayDLEntry,
								duration				: duration_2,
								details					: '',
							})
						});
					}

					var result = that.duplicates_leads;
					if(result.length > 0) {
						that.setCollapseParams();
						that.selectedLead.entry = that.gridData[that.selectedLead.id];
						that.selectedLead.entry.duplicates_leads = result;
						that.leadEnrichmensList = [];
						that.myStatus.forEach( function(item) {
							if ( item.id == that.selectedLead.entry.statusId  ) {
								that.statusStyle.backgroundColor = item.color;
								that.statusStyle.borderColor	 = item.color;
							}
						})
					} else {
						that.setDefaultCollapseParams();
						that.selectedLead.entry = that.gridData[that.selectedLead.id];
						that.selectedLead.entry.duplicates_leads = result;
						that.leadEnrichmensList = [];
						that.myStatus.forEach( function(item) {
							if ( item.id == that.selectedLead.entry.statusId  ) {
								that.statusStyle.backgroundColor = item.color;
								that.statusStyle.borderColor	 = item.color;
							}
						})
					}

					let ownerForeach = ''
					that.owners.forEach( function(owner) {
						if( that.selectedLead.entry.assigned_user_id == owner.id ) {
							ownerForeach = owner
						}else if(that.selectedLead.entry.assigned_user_id == null){
							ownerForeach = ''
						}
					})
					that.selectedOwner = ownerForeach
					

				}).catch(() => {
									
				});
				/* Lead duplicate */

				

				//setTimeout(function() {
				
				//}, 0);
			},
			getUserInfo(action = '') {
				let that = this
				this.optionsSelectSource.defaultSelected = ''
				let url   = 'get_user_info'
				let method= 'GET'
				let data  = {}
				that.loadingData = true

				that.$store.dispatch( 'apiRequest', { url, method, data } ).then((response) => {
					
					that.loadingData = false
					that.myStatus = []

					that.smtp = response.data.smtp;
					console.log('gridcolumn',that.gridColumns.length );
						response.data.lead_columns.forEach( function(item) {
							if( item.type == "custom" && that.customColumns == false) {
								that.gridColumns.push({ title: item.libelle, column: item.type + '_' + item.libelle, enable: false })
							}
						})
						that.customColumns = true


						that.gridColumns.forEach( function( item ) {
						
							if(item.column == 'details'){
								console.log('true : ',item.column)
								that.detailsExist = true
							}

						})

						if(that.detailsExist == false){
							that.gridColumns.push({ title: this.$t('Details'), column: 'details', enable: true })
						}

						//that.gridColumns.push({ title: this.$t('Details'), column: 'details', enable: true })

						//console.log('gridcolumn',that.gridColumns.length );
						

					
					
					let SelectedCols = localStorage.getItem('selected-cols')
					if( SelectedCols != null ) {
						SelectedCols = JSON.parse(SelectedCols)
						that.gridColumns.forEach( function( item ) {
							item.enable = SelectedCols.includes(item.column)
						} )
					} else {
						SelectedCols = []
						that.gridColumns.forEach( function( item ) {
							if( item.enable ) {
								SelectedCols.push(item.column)
							}
						} )
						localStorage.setItem('selected-cols', JSON.stringify(SelectedCols) )
					}
								
					if ( action == 'filter' ) {
						let countSt = that.tableSearch.selectedStatus.length
						that.tableSearch.selectedStatus.splice(0, countSt)
					} else {
						that.emailArray.arrayEmailTemplates = []
						that.mySources = []
					}

					let mystatus = response.data.status
					that.allStatus = [];
					mystatus.forEach( function(entry) {
						that.allStatus.push({ id: entry.id, title: entry.state, option: entry.state, color: entry.color })
						if( entry.status == 1 ) {
							that.myStatus.push({ id: entry.id, title: entry.state, option: entry.state, color: entry.color })
						}
					} );
					
					if( that.tableSearch.selectedStatus.length == 0 ) {
						mystatus.forEach( function(entry) {
							if( entry.defaut == 1 ) {
								that.tableSearch.selectedStatus.push(entry.id)
							}
						} );
					} else {
						var selectedStatus = []
						that.tableSearch.selectedStatus.forEach( function (status) {
							selectedStatus.push(status)
						} )
						that.tableSearch.selectedStatus.splice(0, selectedStatus.length)
						selectedStatus.forEach( function(status) {
							that.tableSearch.selectedStatus.push(status)
						} )
					}

					that.owners = [];
					if(!this.$store.state.active || (this.$store.state.active && 'manage assigned and unassigned leads' in this.$store.state.permissions)){
					// that.owners.push({ title: 'Unassigned', id:0, enable: false})

					}
					let members = response.data.members
					members.forEach( function(item) {
						that.owners.push({ title: item.name, id: item.id, enable: false})
					})
					if( that.tableSearch.assigned_user_id.length == 0 ) {
						that.owners.forEach( function(item) {
							that.tableSearch.assigned_user_id.push(item.id)
						})
					}else{
						var assigned_user_id = []
						that.tableSearch.assigned_user_id.forEach( function (member) {
							assigned_user_id.push(member)
						} )
						that.tableSearch.assigned_user_id.splice(0, assigned_user_id.length)
						assigned_user_id.forEach( function(member) {
							that.tableSearch.assigned_user_id.push(member)
						} )
					}


					that.Filters = [];
					let filters = response.data.filters
					filters.forEach( function(item) {
						that.Filters.push({id: item,title: item})
					})
					if( that.tableSearch.selectedFilter.length == 0 ) {
						let vary = false
						console.log(vary)
					}else{
						var selectedFilter = []
						that.tableSearch.selectedFilter.forEach( function (filter) {
							selectedFilter.push(filter)
						} )
						that.tableSearch.selectedFilter.splice(0, selectedFilter.length)
						selectedFilter.forEach( function(filter) {
							that.tableSearch.selectedFilter.push(filter)
						} )
					}

					if ( action != 'filter' ) {
						response.data.emailsTemplates.forEach( function(model) {
							that.emailArray.arrayEmailTemplates.push({id: model.id, title: model.title, sujet: model.subject, body: model.body})
						} );

						let selectSource = true, SourceCount = that.tableSearch.selectedSources.length
						let MySelectedSource = []
						
						that.tableSearch.selectedSources.forEach( function(source) {
							MySelectedSource.push(source)
						} )
						that.tableSearch.selectedSources.splice(0, SourceCount)
						
						response.data.sources.forEach( function(source) {
							that.mySources.push({ id: source.id, title: source.name, color: "entry.color" })
							
							if ( that.$route.params.source == source.id && SourceCount == 0 ) {
								selectSource = false
								that.tableSearch.selectedSources.push(source.id)
							}
						});
						
						if( MySelectedSource.length > 0 ) {
							MySelectedSource.forEach( function(source) {
								that.tableSearch.selectedSources.push(source)
							} )
						}

						/*if( that.owners.length != 0 ) {
							that.owners.push({ title: 'Unassigned', id:0, enable: false})
							response.data.members.forEach( function(item) {
								that.owners.push({ title: item.name, id: item.id, enable: false})
							})
							that.owners.forEach( function(item) {
								that.tableSearch.assigned_user_id.push(item.id)
							})
						}

						
						that.owners.push({ title: 'Unassigned', id:0, enable: false})
						response.data.members.forEach( function(item) {
							that.owners.push({ title: item.name, id: item.id, enable: false})
						})

						
						response.data.members.forEach( function(item) {
							that.tableSearch.assigned_user_id.push(item.id)
						})*/

						

						
						
						if( (selectSource && SourceCount == 0) || MySelectedSource.length == that.mySources.length ) {
							this.optionsSelectSource.defaultSelected = 'All'
						} else {
							that.getLeads(true, action)
						}
					} else {
						that.getLeads(true, action)
					}

					/*let urlOwners   = '/teammember/teamMembers'
					let methodOwners= 'GET'
					let dataOwners  = {}
					that.loadingData = true
					that.$store.dispatch( 'apiRequest', { urlOwners, methodOwners, dataOwners } ).then((resp) => {
						that.owners = resp.data.members;
						console.log('owners :' + that.owners)

						that.owners.forEach( function(item) {
							that.tableSearch.assigned_user_id.push(item.id)
						})
					})*/
					//console.log(that.gridColumns)

					
					
				}).catch(( {response} ) => {
					console.log(response)
					that.loadingData = false
					that.processing = false
				})

				
			},
			duration(date1,date){
				let that = this
				var diff = Math.floor(date1.getTime() - date.getTime());
				var day = 1000 * 60 * 60 * 24;
				var days = Math.floor(diff/day);
				var months = Math.floor(days/31);
				var years = Math.floor(months/12);
				let message = '';
				if( years == 0 && months == 0 ) {
					if( days > 0 ) {
						message = days + that.$t("DaysAgo"); 
					} else {
						if( date1.getHours() - date.getHours() > 3 ) {
							message = that.$t("Today"); 
						} else {
							message =  that.$t("New"); 
						}
					}
				} else if ( years == 0 && months > 0 ) {
					if ( months == 1 ) {
						message = months + that.$t("MonthAgo")
					} else {
						message = months + that.$t("MonthsAgo")
					}
				} else if ( years > 0 ) {
					if ( years == 1 ) {
						message = years + that.$t("YearAgo")
					} else {
						message = years + that.$t("YearsAgo")
					}
				}
				return message;
			},
			getLeads(bottomOfWindow, action = '') {

				let that = this

				let leadGetter = that.leadGetter
				
				if ( that.gridData.length == that.totalLead && that.totalLead != 0 ) {
					that.moreData = true
				} else {
					that.moreData = false
				}
				
				if ( action == 'filter' ) {
					that.current_page = 1
					leadGetter = true
					that.searchCount += 1;
				}

				if ( action == 'filter' && that.$store.state.clickFilter == true ) {
					that.showSaveView = true
				}else{
					that.showSaveView = false
				}

				if(that.$store.state.clickSmartView == true){
					let vary = false
					console.log(vary)
				}else{
					that.$store.state.smartViewsItem == []
					that.$store.state.clickSmartView = false;
				}
				
				
				if (that.tableSearch.selectedSources.length == 0 && that.tableSearch.selectedStatus.length == 0) {
					return false
				}

				let selectedFilterAll = []
				if(that.tableSearch.selectedFilter.length == that.Filters.length){
					selectedFilterAll.push('all')
				}else{
					selectedFilterAll = that.tableSearch.selectedFilter
				}
				
				if( bottomOfWindow && that.last_page >= that.current_page && leadGetter ) {
					
					that.leadGetter  = false
					that.loadingData = true

					
					
					let url   = 'myLeads?page=' + that.current_page
					let method= 'POST'
					let data  = { searchQuery:that.tableSearch.searchQuery, selectedSources:that.tableSearch.selectedSources, selectedStatus:that.tableSearch.selectedStatus, dateRange:that.dateRange, selectedFilter:selectedFilterAll, assigned_user_id:that.tableSearch.assigned_user_id}
					
					that.$store.dispatch('apiRequest', { url, method, data } ).then((response) => {
						
						if ( action == 'filter' ) {
							that.gridData = []
							that.searchCount -= 1;
						}
						let myLeads = response.data.myLeads.data
						
						let DemoData = localStorage.getItem('DemoData')
						if ( that.DemoDataPanel && DemoData == 'first' ) {
							localStorage.removeItem('DemoData')
							DemoData = true
						} else {
							DemoData = false
						}
						myLeads.forEach( function(lead) {
							let entryLeads = Object.keys( lead.entry ), arrayEntry = [], entryValues = Object.values( lead.entry )
							if ( entryLeads.length > 0 ) {
								entryLeads.forEach( function(item, key) {
									arrayEntry.push( { name: item, value: entryValues[key], fieldSelected: "custom_field" } )
								} );
							}
							var date1 = new Date()
							var date2 = new Date(lead.created_at)
							var duration = that.duration(date1,date2)
							that.gridData.push(
								{ 
									id				: lead.id,
									full_name		: (lead.full_name == null || lead.full_name == '') ? lead.personal_first_name + ' ' + lead.personal_last_name : lead.full_name,
									personal_first_name: lead.personal_first_name == null ? '' : lead.personal_first_name,
									personal_last_name: lead.personal_last_name == null ? '' : lead.personal_last_name,
									status			: lead.param.state,
									score			: lead.scoring,
									email			: lead.email == null ? '' : lead.email,
									personal_phone	: lead.personal_phone == null ? '' : lead.personal_phone,
									generatedOn		: lead.created_at,
									updated_at		: lead.updated_at,
									source			: lead.source.name/* lead.source_id */,
									color			: lead.param.color,
									statusId		: lead.param.id,
									historic		: lead.historiques,
									notes			: lead.notes,
									duplicates_leads: [],
									email_verified	: lead.email_verified,
									phone_verified	: lead.phone_verified,
									enabled			: lead.enabled,
									entry			: arrayEntry,
									duration		: duration,
									details			: '',
									is_duplicate    :lead.is_duplicate,
									assigned_action	: lead.assigned_action,
									assigned_user_id	: lead.assigned_user_id,
									email_historiques   : lead.email_historiques,
								}
							)

							if( lead.enabled == 0 ) {
								that.ColumnBlur++
							}
										
							entryLeads.forEach( function(item) {
								that.gridColumns.forEach( function(col) {
									if( col.title == item ) {
										that.gridData[that.gridData.length - 1][col.column] = lead.entry[item] // id
									}
								} )
							} )
						} );
						
						if ( that.gridData.length == that.totalLead ) {
							that.moreData = true
						} else {
							that.moreData = false
						}
						/* if ( that.last_page == that.current_page ) {
							that.moreData = true
						} */
						
						that.last_page = response.data.myLeads.last_page
						that.current_page += 1
						// if( that.last_page > that.current_page ) {
						// }
						that.totalLead = response.data.myLeads.total
						
						that.leadGetter = true
						
						if (that.searchCount < 1) {
							that.loadingData = false
							this.processing = false
						}
						
					}).catch(( {response} ) => {
						console.log(response)
						that.loadingData = false
						this.processing = false
					})
					
				}
			},
			smartViewsFilter() {
				let that = this;
				that.current_page = 1
				that.gridData = []
				var filter = JSON.parse(that.smartViewsItem.filter);
				var dateRange = (typeof filter.dateRange == 'string') ? JSON.parse(filter.dateRange) : filter.dateRange;
				that.tableSearch.searchQuery = (filter.searchQuery) ? filter.searchQuery : '';

				if(filter.assigned_user_id.length >= 0) {
					console.log(filter.assigned_user_id)
					var selectedAssignedUser = []
					that.tableSearch.assigned_user_id.forEach( function (assignedUser) {
						selectedAssignedUser.push(assignedUser)
					} )
					that.tableSearch.assigned_user_id.splice(0, selectedAssignedUser.length)
					
					filter.assigned_user_id.forEach( function(assignedUserItem) {
						that.tableSearch.assigned_user_id.push(assignedUserItem)
					})
				}

				if(filter.selectedStatus.length > 0) {
					var selectedStatus = []
					that.tableSearch.selectedStatus.forEach( function (status) {
						selectedStatus.push(status)
					} )
					that.tableSearch.selectedStatus.splice(0, selectedStatus.length)
					filter.selectedStatus.forEach( function(statusItem) {
						that.tableSearch.selectedStatus.push(statusItem)
					})
				}
				if(filter.selectedSources.length > 0) {
					var selectedSources = []
					that.tableSearch.selectedSources.forEach( function (source) {
						selectedSources.push(source)
					} )
					that.tableSearch.selectedSources.splice(0, selectedSources.length)
					filter.selectedSources.forEach( function(sourceItem) {
						that.tableSearch.selectedSources.push(sourceItem)
					})
				}
				if(filter.selectedFilter.length >= 0) {
					var selectedFilter = []
					that.tableSearch.selectedFilter.forEach( function (filter) {
						selectedFilter.push(filter)
					})
					that.tableSearch.selectedFilter.splice(0, selectedFilter.length)
					filter.selectedFilter.forEach( function(filterItem){
						that.tableSearch.selectedFilter.push(filterItem)
					})
				}

				if(Object.keys(dateRange).length != 0) {
					that.dateRange = dateRange;
				} else {
					that.dateRange = {};
				}
			},
			selectionChange() {
				this.$forceUpdate();
			},
			changeTemplate() {
				let that = this;
				console.log(that.emailArray.arrayEmailTemplates[this.emailArray.selectedTemplate])
				this.emailArray.Subject = (that.emailArray.selectedTemplate !== '') ? that.emailArray.arrayEmailTemplates[that.emailArray.selectedTemplate].sujet : ''
				this.emailArray.contentMessage = (that.emailArray.selectedTemplate !== '') ? that.emailArray.arrayEmailTemplates[that.emailArray.selectedTemplate].body : ''
				// this.emailArray.selectedTemplate = 
			},
			
			discardEmail() {
				this.emailArray.Subject = ''
				this.emailArray.contentMessage = ''
			},
			
			sendEmail() {
				let that   = this;
				that.emailArray.to = that.selectedLead.entry.email
				let url    = 'fiche_lead/send_email';
				let method = 'POST';
				let data   = {from:that.emailArray.from,to:that.emailArray.to,subject:that.emailArray.Subject,body:that.emailArray.contentMessage,leadId:that.selectedLead.entry.id};
				that.$store.dispatch('apiRequest', {url,method,data}).then((response) => {
					//let message = response.data.message;
					if(response.data.success) {
						that.emailArray.Subject = ''
						that.emailArray.contentMessage = ''
						that.emailArray.selectedTemplate = ''
						//that.gridData[that.selectedLead.id].notes = response.data.notes
						that.selectedLead.entry.notes = response.data.notes
						that.selectedLead.entry.email_historiques = response.data.email_historiques
						that.notifyMe(this.$t('emailSentLead'), 'success')
					}
				}).catch(( {response} ) => {
					that.processing = false
					that.notifyMe(response.data.message, 'warn')
				})
			},
			
			addNewLeads() {
				let that = this
								
				if ( Object.values(that.validateField).indexOf(true) == -1 ) {
					
					that.processing = true
					
					let url   = 'leads/add_new_lead'
					let method= 'POST'
					let data  = { arrayLead: that.newLead, customField: that.arrayFieldsAddLead, provider : "add leads" , permissionid : 11}
					
					that.$store.dispatch('apiRequest', { url, method, data } ).then((response) => {
						// let message = response.data.message
						if ( response.data.success ) {
							
							if ( response.data.sources.length > 0 ) {
								that.tableSearch.selectedSources = []
								that.mySources = []
								response.data.sources.forEach( function(source) {
									that.mySources.push({ id: source.id, title: source.name, color: "entry.color" })
								} );
							} else {
								that.getLeads(true, 'filter')
							}
							
							that.newLead.full_name = ''
							that.newLead.personal_first_name = ''
							that.newLead.personal_last_name = ''
							that.newLead.personal_phone = ''
							that.newLead.email = ''
							that.newLead.status = ''
							that.arrayFieldsAddLead = []
							that.leftSidebarInfo()
							that.notifyMe(this.$t('ChangesSaved'), 'success')
							that.$bvModal.hide('bv-modal-addLead')
							
						} else {
							let varKey  = Object.keys( response.data.message ) //, valuesObj = Object.values( response.data.message );
							var message = ''
							let objMsg  = response.data.message
							varKey.forEach( function(item) {
								message += objMsg[item] + "<br>"
							} )
							that.notifyMe(message, 'warn')
						}
						that.processing = false
					}).catch(( {response} ) => {
						that.processing = false
						that.notifyMe(response.data.message, 'warn')
					})
					
				} else {
					that.notifyMe(this.$t('fieldRequired'), 'warn')
				}
				
			},
			connectEnrichment() {
				let that = this, search = ''
				that.dataEnrichmens.loading = true
				// that.selectedLead.entry.email_verified == 1
				if( that.selectedLead.entry.email != '' && that.selectedLead.entry.email_verified == 1 ) {
					search = that.selectedLead.entry.email
				} else if( that.selectedLead.entry.personal_phone != '' && that.selectedLead.entry.phone_verified == 1 ) {
					search = that.selectedLead.entry.email != '' ? that.selectedLead.entry.personal_phone : that.selectedLead.entry.email
				}
				if( search != '' ) {					
					let url   = 'enrichment/search'
					let method= 'POST'
					let data  = {search:search}
					that.$store.dispatch('apiRequest', { url, method, data } ).then((response) => {
						that.dataEnrichmens.loading = false
						if( response.data.success ) {
							if( Object.keys(response.data.result).length > 0 ) {
								that.leadEnrichmensList = response.data.result
							} else {
								that.notifyMe(this.$t('dataNotFound'), 'warn')
							}
						} else {
							that.notifyMe(response.data.message, 'warn')
						}
					}).catch(( {response} ) => {
						that.dataEnrichmens.loading = false
						that.notifyMe(response.data.message, 'warn')
					})
				} else {
					that.notifyMe(this.$t('emailPhoneMustValid'), 'warn')
					that.dataEnrichmens.loading = false
				}
			},
			
			listLeadEnrichment() {
				
				let that = this
				that.dataEnrichmens.status = false
				
				let url   = 'enrichment/connected_list'
				let method= 'GET'
				let data  = {provider : "enrich leads", permissionid : 16}
				
				that.$store.dispatch('apiRequest', { url, method, data } ).then((response) => {
					if( response.data.enrichmens.length > 0 ) {
						that.dataEnrichmens.name = response.data.enrichmens[0].provider
						that.dataEnrichmens.status = true
					}
				}).catch(( {response} ) => {
					console.log(response)
				})
				
			},
			//duplicates(id) {
				//let that = this
				//let url   = 'lead/duplicates'
				//let data  = {id:id}
				//console.log(id)
				//that.$store.dispatch('lead_details', { url, data } ).then((response) => {
					//console.log(response)
				//}).catch(( {response} ) => {
					//console.log(response)
				//})
			//},
			actionClick( itemIdsArray = "", action = "" ) {
				let that = this
				that.url = this.$store.state.calendly_url;

				console.log('azizHere : '+ that.selectedLead.entry.assigned_user_id)

				if( action == 'itemIdsArray' ) {
					that.itemIds = itemIdsArray
					console.log('URL : '+ this.$store.state.calendly_url)
					if (this.$store.state.calendly_url || this.$store.state.calendly_url != "") {
						const myurl = new URL(this.$store.state.calendly_url);
						myurl.searchParams.set('name', itemIdsArray.full_name?itemIdsArray.full_name:itemIdsArray.personal_first_name+' '+itemIdsArray.personal_last_name);
						myurl.searchParams.set('email', itemIdsArray.email);
						that.url = myurl.href;
					}

				} else if(that.selectedLead.entry.enabled == 1) {
					console.log('URL : '+ this.$store.state.calendly_url)
					if (this.$store.state.calendly_url || this.$store.state.calendly_url != "") {
						const myurl = new URL(this.$store.state.calendly_url);
						myurl.searchParams.set('name', that.selectedLead.entry.full_name?that.selectedLead.entry.full_name:that.selectedLead.entry.personal_first_name+' '+that.selectedLead.entry.personal_last_name);
						myurl.searchParams.set('email', that.selectedLead.entry.email);
						that.url = myurl.href;
					}

					that.owners.forEach( function(owner) {
						if( that.selectedLead.entry.assigned_user_id == owner.id ) {
							that.selectedOwner = owner
						}
					})

					/* Lead duplicate */
					that.leadDetails(that.selectedLead.entry.id,that.selectedLead.entry);
					that.selectedLead.entry.duplicates_leads = that.duplicates_leads;
					/* Lead duplicate */
					//that.$bvModal.show('bv-modal-leadDetails')
					that.listLeadEnrichment()
					that.myStatus.forEach( function(item) {
						if ( item.id == that.selectedLead.entry.statusId  ) {
							that.statusStyle.backgroundColor = item.color
							that.statusStyle.borderColor	 = item.color
						}
					} )	
					if( action == 'sendEmail' ) {
						that.tabsFocus = false
					} else {
						that.tabsFocus = true
					}
				}
			},
			leftSidebarInfo() {
				let that = this
				let url   = 'left_sidebar'
				let method= 'GET'
				let data  = {}
				that.$store.dispatch('apiRequest', { url, method, data } ).then((response) => {
					console.log(response)
					that.$store.dispatch('GetClients')
				}).catch(( {response} ) => {
					console.log(response)
				})
			},
			
			scroll() {
				let that = this
				window.onscroll = () => {
					// let bottomOfWindow = document.documentElement.scrollTop + window.innerHeight === document.documentElement.offsetHeight;
					let bottomOfWindow = document.documentElement.scrollTop + window.innerHeight + 5 >= document.documentElement.offsetHeight;
					if (bottomOfWindow) {
						that.getLeads(bottomOfWindow, '')
					}
				};
				// let that = this
				/* window.onscroll = () => {
					let bottomOfWindow = document.documentElement.scrollTop + window.innerHeight === document.documentElement.offsetHeight;
					if( that.current_page != 1 ) {
						that.getLeads(bottomOfWindow, '')
					}
				}; */
			},
			
			arcMove(lineCap, Number) {
				let percent = ( Number / 10) * 100
				var can 		= document.getElementById('canvas'),
					spanProcent = document.getElementById('procent'),
					c 			= can.getContext('2d');
				var posX 		= can.width / 2,
					posY 		= can.height / 2,
					fps 		= 1000 / 200,
					// procent 	= 0,
					oneProcent 	= 360 / 100,
					result 		= oneProcent * percent;
				
				c.lineCap = lineCap;
				
				
				var deegres = 0;
				clearInterval(acrInterval);
				var acrInterval = setInterval (function() {
					deegres += 1;
					c.clearRect( 0, 0, can.width, can.height );
					// procent = deegres / oneProcent;
					
					spanProcent.innerHTML = '<div><span>' + Number + '</span>/10' + '</div>';
					
					c.beginPath();
					c.arc( posX, posY, 100, (Math.PI/180) * 270, (Math.PI/180) * (270 + 360) );
					c.strokeStyle = '#dddddd';
					c.lineWidth = '6';
					c.stroke();
					
					c.beginPath();
					c.strokeStyle = '#00BBF6';
					c.lineWidth = '6';
					c.arc( posX, posY, 100, (Math.PI/180) * 270, (Math.PI/180) * (270 + deegres) );
					c.stroke();
					if( deegres >= result ) clearInterval(acrInterval);
				}, fps);
			},
			getDefaultStatus() {
				let that = this
				that.myStatus.forEach( function(item) {
					if(item.title == 'Pending' || item.title == 'En attente') {
						that.newLead.status = item.id
					}
				});
			},
			myLeadDetail: function(entry,id=0,action='') {
				let that   = this
				let url    = 'lead_details'
				let method = 'GET'
				let data   = {'lead_id':entry.id}
				that.duplicates_leads = [];
				that.$store.dispatch('apiRequest', {url, method, data }).then((response) => {
					if(response.data.success == true) {
						var duplicatesLeads = response.data.duplicatesLeads;
						duplicatesLeads.forEach( function(duplicates_lead) {
							let duplicateLeadEntry = Object.keys( duplicates_lead.entry ), arrayDLEntry = [], entryDLValues = Object.values( duplicates_lead.entry )
							if ( duplicateLeadEntry.length > 0 ) {
								duplicateLeadEntry.forEach( function(item, key) {
									arrayDLEntry.push( { name: item, value: entryDLValues[key], fieldSelected: "custom_field" } )
								});
							}
							var date1 = new Date()
							var date = new Date(duplicates_lead.created_at)
							var duration_2 = that.duration(date1,date)
							that.duplicates_leads.push({
								id : duplicates_lead.id,
								full_name: (duplicates_lead.full_name == null || duplicates_lead.full_name == '') ? duplicates_lead.personal_first_name + ' ' + duplicates_lead.personal_last_name : duplicates_lead.full_name,
								personal_first_name		: duplicates_lead.personal_first_name == null ? '' : duplicates_lead.personal_first_name,
								personal_last_name		: duplicates_lead.personal_last_name == null ? '' : duplicates_lead.personal_last_name,
								status					: duplicates_lead.param.state,
								score					: duplicates_lead.scoring,
								email					: duplicates_lead.email == null ? '' : duplicates_lead.email,
								personal_phone			: duplicates_lead.personal_phone == null ? '' : duplicates_lead.personal_phone,
								generatedOn				: duplicates_lead.created_at,
								updated_at				: duplicates_lead.updated_at,
								source					: duplicates_lead.source.name,
								color					: duplicates_lead.param.color,
								statusId				: duplicates_lead.param.id,
								historic				: duplicates_lead.historiques,
								notes					: duplicates_lead.notes,
								email_verified			: duplicates_lead.email_verified,
								phone_verified			: duplicates_lead.phone_verified,
								enabled					: duplicates_lead.enabled,
								is_duplicate	        : duplicates_lead.is_duplicate,
								entry					: arrayDLEntry,
								duration				: duration_2,
								details					: '',
							})
						});
						if(action == 'view') {
							that.actionLead(entry,id,action,that.duplicates_leads);
						}
					}
				}).catch(() => {
									
				});
				return  that.duplicates_leads;
			},
			toggleModal: function() {
				let that = this;
				that.closeModalLeadDetails();
			},
			actionLead: function(entry, id, action,result) {
				if(action == 'view') {		
					let that = this;
					if(result.length > 0) {
						that.setCollapseParams();
						that.selectedLead.id = id;
						that.selectedLead.entry = entry;
						that.selectedLead.entry.duplicates_leads = result;
						that.allStatus.forEach( function(item) {
							if ( item.id == that.selectedLead.entry.statusId  ) {
								that.statusStyle.backgroundColor = item.color;
								that.statusStyle.borderColor	 = item.color;
							}
						})
					}  else {
						that.selectedLead.id = id;
						that.selectedLead.entry = entry;
						that.selectedLead.entry.duplicates_leads = result;
						that.allStatus.forEach( function(item) {
							if ( item.id == that.selectedLead.entry.statusId  ) {
								that.statusStyle.backgroundColor = item.color;
								that.statusStyle.borderColor	 = item.color;
							}
						})
					}
				}
			},
			markAsADuplicate: function(entry) {
				let that = this
				function estDuplicate(monStatus) {
					return (monStatus.title == 'Duplicate' || monStatus.title == 'Doublon')  ? monStatus.title : '';
				}
				var statusId = that.allStatus.find(estDuplicate).id;
				if(statusId != entry.statusId) {
					that.allStatus.forEach( function(item) {
						if ( item.id == statusId ) {
							that.statusStyle.backgroundColor = item.color
							that.statusStyle.borderColor	 = item.color
							entry.status = item.title
							that.gridData[ that.selectedLead.id ].status = item.title
							that.gridData[ that.selectedLead.id ].color  = item.color
							that.selectedLead.entry.statusId = statusId
						}
					})
					let url   = 'leads/change_status'
					let method= 'PATCH'
					let data  = {leadId: entry.id, newStatus: statusId, provider : "edit status"}
					that.$store.dispatch('apiRequest', { url, method, data } ).then((response) => {
						if( response.data.success ) {
							if( response.data.message) {
								let myMessage = response.data.message
								that.notifyMe(myMessage,'success')
							}
							if( response.data.sent ) {
								that.notifyMe(this.$t('leadHasBeenSent'), 'success')
							} //else {
								//that.notifyMe('Status Changed !', 'success')
							//}
							that.gridData[ that.selectedLead.id ].historic = response.data.historiques
							that.selectedLead.entry.historic = response.data.historiques
							that.gridData[ that.selectedLead.id ].notes = response.data.notes
							that.selectedLead.entry.notes = response.data.notes
						}
					}).catch(( {response} ) => {
						console.log(response)
					})
				}
			},
			setDefaultCollapseParams: function() {
				let that = this;
				that.visible_collapse_1 = true;
				that.visible_collapse_2 = false;
			},
			setCollapseParams: function() {
				let that = this;
				that.visible_collapse_1 = false;
				that.visible_collapse_2 = true;
			},
			leadDetails: function(leadId,entry) {
				let that   = this
				let url    = 'lead_details'
				let method = 'GET'
				let data   = {'lead_id':leadId}
				that.duplicates_leads = [];
				console.log(entry)
				that.$store.dispatch( 'apiRequest', { url, method, data }).then((response) => {
					that.visible_collapse_1 = true
					that.visible_collapse_2 = false
					if(response.data.success == true) {
						if(response.data.duplicatesLeads.length > 0) {
							var duplicatesLeads = response.data.duplicatesLeads;
							duplicatesLeads.forEach( function(duplicates_lead) {
								let duplicateLeadEntry = Object.keys( duplicates_lead.entry ), arrayDLEntry = [], entryDLValues = Object.values( duplicates_lead.entry )
								if ( duplicateLeadEntry.length > 0 ) {
									duplicateLeadEntry.forEach( function(item, key) {
										arrayDLEntry.push( { name: item, value: entryDLValues[key], fieldSelected: "custom_field" } )
									});
								}
								var date1 = new Date()
								var date = new Date(duplicates_lead.created_at)
								var duration_2 = that.duration(date1,date)
								that.duplicates_leads.push({
									id : duplicates_lead.id,
									full_name: (duplicates_lead.full_name == null || duplicates_lead.full_name == '') ? duplicates_lead.personal_first_name + ' ' + duplicates_lead.personal_last_name : duplicates_lead.full_name,
									personal_first_name		: duplicates_lead.personal_first_name == null ? '' : duplicates_lead.personal_first_name,
									personal_last_name		: duplicates_lead.personal_last_name == null ? '' : duplicates_lead.personal_last_name,
									status					: duplicates_lead.param.state,
									score					: duplicates_lead.scoring,
									email					: duplicates_lead.email == null ? '' : duplicates_lead.email,
									personal_phone			: duplicates_lead.personal_phone == null ? '' : duplicates_lead.personal_phone,
									generatedOn				: duplicates_lead.created_at,
									updated_at				: duplicates_lead.updated_at,
									source					: duplicates_lead.source.name,
									color					: duplicates_lead.param.color,
									statusId				: duplicates_lead.param.id,
									historic				: duplicates_lead.historiques,
									notes					: duplicates_lead.notes,
									email_verified			: duplicates_lead.email_verified,
									phone_verified			: duplicates_lead.phone_verified,
									enabled					: duplicates_lead.enabled,
									is_duplicate	        : duplicates_lead.is_duplicate,
									entry					: arrayDLEntry,
									duration				: duration_2,
									details					: '',
								})
							})
							that.setCollapseParams();
						}
					}
				}).catch(() => {
						
				})
			},
			set_email_data: function () {
				let that = this;	
				let url    = 'get_actif_smtp';
				let method = 'GET';
				let data = {};
				that.$store.dispatch('apiRequest', {url, method,data}).then((response) => {
					if(response.data.success){
						let smtp = response.data.smtp;
						if(smtp) {
							that.emailArray.from = smtp.email;
						} else {
							var UserCheck = JSON.parse(localStorage.getItem('oml-user'))
							that.emailArray.from = UserCheck.email;
						}
					}
				});
			},
			adjustLeadInfoEditorDropdown: function () {
				var element = document.getElementsByClassName("ql-selected");
				if(element.length > 0) {
					element[0].classList.remove("ql-selected");
				}
				let placeholderPickerItems = Array.prototype.slice.call(document.querySelectorAll('.ql-placeholder .ql-picker-item'));
				placeholderPickerItems.forEach(item => item.textContent = item.dataset.value);
				const label = document.querySelector('.ql-placeholder .ql-picker-label');
				label.innerHTML = '';	
				label.innerHTML = 'Lead infos <svg viewBox="0 0 18 18" style="margin-top: -11px;"> <polygon class="ql-stroke" points="7 11 9 13 11 11 7 11"></polygon> <polygon class="ql-stroke" points="7 7 9 5 11 7 7 7"></polygon> </svg>';
			},
			test: function(anglet){
				let that = this;
				if(anglet == 'send_email') {
					that.anglet_value = 'send_email';
					that.adjustLeadInfoEditorDropdown();
				} else {
					that.anglet_value = 'lead_detail';
				}
			},
			addSmartView(){
				let that = this;
				console.log(that)
				that.$bvModal.show('add_view');
			},
			closeAddSmartViewModal(){
				let that = this;
				that.smartview.id=0;
				that.smartview.name='';
			},
			saveSmartView(){
				let that = this;
				console.log(typeof that.tableSearch);
				console.log(that.dateRange);
				console.log(that.smartview.name);
				if(that.smartview.name != ""){
					let url   = 'save_filters';
					let method= 'POST';
					let data  = {name:that.smartview.name,searchQuery:that.tableSearch.searchQuery, selectedSources:that.tableSearch.selectedSources, selectedStatus:that.tableSearch.selectedStatus, dateRange:that.dateRange, selectedFilter:that.tableSearch.selectedFilter,assigned_user_id: that.tableSearch.assigned_user_id};
					console.log('data saveview :' + data)
					that.$store.dispatch('apiRequest', { url, method, data }).then((response) => {
						console.log(response.data.success);
						if(response.data.success){
							that.$store.state.reloadLeftSidebarCompenent = Math.random();
							that.$store.state.checkChange = true;
							that.closeAddSmartViewModal();
							that.$bvModal.hide('add_view');
							that.notifyMe(this.$t('yourSmartViewSent'), 'success')
						}
					}).catch(({response}) => {	
						console.log(response);
					})
				}else{
					let messageError = this.$t('mustEnterName')
					that.notifyMe(messageError, 'warn')
				}
				
			},
			bulkActionSelectWorkspace: function(workSpace_id,lead_id){
				this.bulkSendTo.client_id = this.$store.state.user.id
				this.bulkSendTo.worspace_id = workSpace_id

				if(lead_id == '' || lead_id == null){
					this.bulkSendTo.lead_id = this.itemIds
				}else{
					this.bulkSendTo.lead_id = []
					this.bulkSendTo.lead_id[0] = lead_id
				}
			},
			bulkActionSend: function(){
				let that = this;
				let url   = '/leads/sendToWorkspace';
				let method= 'POST';
				let data  = that.bulkSendTo
				
				that.$store.dispatch('apiRequest', { url, method, data } ).then((response) => {
					console.log(response)
                    that.getLeads(true, 'filter')
					this.$refs.dropdownBulk.hide(true)
					this.$refs.dropdownFicheLead.hide(true)
					that.notifyMe(this.$t('leadSentToWorkspace'), 'success')
					this.bulkSendTo.lead_id = []
					this.bulkSendTo.worspace_id = null

				}).catch(( {response} ) => {
					console.log(response)
					that.notifyMe(response.data.message, 'warn');
				})
			},
			bulkOwnerSelectWorkspace: function(owner_id){
				this.bulkOwners.client_id = this.$store.state.user.id
				this.bulkOwners.assignedTo = owner_id
				this.bulkOwners.leads = this.itemIds
			},
			bulkOwnerSend: function(){
				if(this.bulkOwners.assignedTo == '' || this.bulkOwners.assignedTo == null){
					this.notifyMe(this.$t('mustChooseMember'), 'warn');
				}else{
					let that = this;
					let url   = '/manage/assigne';
					let method= 'POST';
					let data  = that.bulkOwners
					
					that.$store.dispatch('apiRequest', { url, method, data } ).then((response) => {
						console.log(response)
						that.getLeads(true, 'filter')
						this.$refs.dropdownBulk.hide(true)
						that.notifyMe(this.$t('leadAssignedToMember'), 'success')
					}).catch(( {response} ) => {
						console.log(response)
						that.notifyMe(response.data.message, 'warn');
					})
				}
			},
			bulkOsixRappel: function(){
				let that = this;
				let url   = 'communication/osix/rappel/senario1';
				let method= 'POST';
				let data  = {lead_ids:that.itemIds}
				
				that.$store.dispatch('apiRequest', { url, method, data } ).then((response) => {
					console.log(response)
					that.getLeads(true, 'filter')
					that.notifyMe('Rappel sent succefuly', 'success')
				}).catch(( {response} ) => {
					console.log(response)
					that.notifyMe(response.data.message, 'warn');
				})
			},
			bulkOsixRappel1: function(){
				let that = this;
				let url   = 'communication/osix/rappel/senario2';
				let method= 'POST';
				let data  = {lead_ids:that.itemIds}
				
				that.$store.dispatch('apiRequest', { url, method, data } ).then((response) => {
					console.log(response)
					that.getLeads(true, 'filter')
					that.notifyMe('"Jeu concours" sent succefuly', 'success')
				}).catch(( {response} ) => {
					console.log(response)
					that.notifyMe(response.data.message, 'warn');
				})
			},
			bulkOsixRappel2: function(){
				let that = this;
				let url   = 'communication/osix/rappel';
				let method= 'POST';
				let data  = {lead_ids:that.itemIds}
				
				that.$store.dispatch('apiRequest', { url, method, data } ).then((response) => {
					console.log(response)
					that.getLeads(true, 'filter')
					that.notifyMe('Call back sent succefuly', 'success')
				}).catch(( {response} ) => {
					console.log(response)
					that.notifyMe(response.data.message, 'warn');
				})
			},
			sendOneOwnerSelected: function(lead_id){
				let that = this;
				console.log('test id : ' + that.selectedLead.entry.assigned_user_id + '    '+ this.selectedOwner.id)
				if(this.selectedOwner.id !== that.selectedLead.entry.assigned_user_id){
					this.bulkOwners.client_id = this.$store.state.user.id
					this.bulkOwners.assignedTo = this.selectedOwner.id
					this.bulkOwners.leads[0] = lead_id

					that.selectedLead.entry.assigned_user_id = this.selectedOwner.id

				
					let url   = '/manage/assigne';
					let method= 'POST';
					let data  = that.bulkOwners
					
					that.$store.dispatch('apiRequest', { url, method, data } ).then((response) => {
						console.log(response)
						that.getLeads(true, 'filter')
						that.notifyMe(this.$t('leadAssignedToMember'), 'success')
						that.selectedLead.entry.assigned_action = response.data.assigned
						this.$refs.dropdown.hide(true)
					}).catch(( {response} ) => {
						console.log(response)
						that.notifyMe(response.data.message, 'warn');
					})
				}
				
				/*that.gridData.forEach( function(entryLead) {
					if(entryLead.id == lead_id){
						that.selectedLead.entry.assigned_action.splice(0)
						console.log(entryLead)
						entryLead.assigned_action.forEach( function(item) {
							that.selectedLead.entry.assigned_action.push(item)
						})
					}
				})*/
			},
			changeNoteKey: function(key){
				this.showMoreNote == key
			},
			ChangeRoute( element ) {
				if(element){
					let that = this;
					that.$store.state.selectedPage = element
					var routerLink = that.$router.resolve({path:'/account/' + element})
					window.open(routerLink.href, '_blank').catch((e)=>{
						if (
							e.name !== 'NavigationDuplicated' &&
							!e.message.includes('Avoided redundant navigation to current location')
						) {
							console.log(e)
						}
					});
					/*that.$router.push({path:'/account/' + element,target: '_blank'}).catch((e)=>{
						if (
							e.name !== 'NavigationDuplicated' &&
							!e.message.includes('Avoided redundant navigation to current location')
						) {
							console.log(e)
						}
					});*/
				}
			},
		},
		created(){
			console.log('created')
		},
		mounted() {
			let that = this

			// refreshing smartViews
			that.$store.state.reloadLeftSidebarCompenent = Math.random();
			that.$store.state.checkChange = true;
			// refreshing smartViews

			/*that.Filters.forEach( function(filter) {
				that.tableSearch.selectedFilter.push(filter.id)
			})*/

			that.set_email_data();
			that.$i18n.locale = localStorage.getItem('i18n_lang')
			that.gridColumns	=  [
				{ title:  this.$t('Id')		   , column: 'id' 		  , enable: false},
				{ title:  this.$t('Name')		   , column: 'full_name'  , enable: true},
				{ title:  this.$t('FirstName')  , column: 'personal_first_name'  , enable: false},
				{ title: this.$t('LastName')   , column: 'personal_last_name'  , enable: false},
				{ title: this.$t('Status')	   , column: 'status'	  , enable: true},
				{ title: this.$t('Email')	   , column: 'email'	  , enable: true},
				{ title: this.$t('Phone')	   , column: 'personal_phone', enable: true},
				{ title: this.$t('GeneratedOn'), column: 'generatedOn', enable: true},
				{ title: this.$t('Source')	   , column: 'source'	  , enable: false},
				//{ title: this.$t('Details'), column: 'details', enable: true},
			];
			// Pusher.logToConsole = true;


			/*let url   = '/teammember/teamMembers'
			let method= 'POST'
			let data  = {}
			
			that.$store.dispatch('apiRequest', { url, method, data } ).then((response) => {
				// that.arrayMembers = []
				//let members = response.data.members

				that.owners.push({ title: 'Unassigned', id:0, enable: false})
				response.data.members.forEach( function(item) {
					that.owners.push({ title: item.name, id: item.id, enable: false})
				})
				that.owners.forEach( function(item) {
					that.tableSearch.assigned_user_id.push(item.id)
				})
				
			}).catch(() => {
				
			})*/


			that.GetTeamRole()
			that.CheckDemoData()
			this.GetPayemetStatut();
			
			var pusher = new Pusher(process.env.VUE_APP_PUSHER_APP_KEY, {
				cluster: process.env.VUE_APP_PUSHER_APP_CLUSTER,
				forceTLS: true
			});
            var channel = pusher.subscribe('team.' + JSON.parse(localStorage.getItem('oml-client')).id + '.leads');
            channel.bind('verified', function(data) {
                var lead = data.lead
                const found = that.gridData.find(element => element.id == lead.id);
                if( typeof(found) != 'undefined' ) {
                    found.email_verified = lead.email_verified
                    found.phone_verified = lead.phone_verified
                }
            });
			channel.bind('osix_event', function(data) {				
                var lead = data.lead
				if(lead.team_id  == JSON.parse(localStorage.getItem('oml-client')).id ) {
					const found = that.gridData.find(element => element.id == lead.id);
					if( typeof(found) != 'undefined' ) {
						found.statusId = lead.status_id
						found.status   = lead.param.state
						found.color   = lead.param.color
					}
				}
            });
            channel.bind('fb_webhook', function(data) {
                data = data.lead
                if(data.team_id  == JSON.parse(localStorage.getItem('oml-client')).id ) {
                    let entryLeads = Object.keys( data.entry ), arrayEntry = [], entryValues = Object.values( data.entry )
                    if ( entryLeads.length > 0 ) {
                        entryLeads.forEach( function(item, key) {
                            arrayEntry.push( { name: item, value: entryValues[key], fieldSelected: "custom_field" } )
                        });
                    }
                    var date1 = new Date()
                    var date2 = new Date( data.created_at ) // remember this is equivalent to 06 01 2010
                    //dates in js are counted from 0, so 05 is june
                    var diff = Math.floor(date1.getTime() - date2.getTime());
                    var day = 1000 * 60 * 60 * 24;
                    var days = Math.floor(diff/day);
                    var months = Math.floor(days/31);
                    var years = Math.floor(months/12);
                    let message = '';
                    if( years == 0 && months == 0 ) {
							if( days > 0 ) {
                                message = days + " Days Ago" 
                            } else {
                                if( date1.getHours() - date2.getHours() > 3 ) {
                                    message = 'Today'
                                } else {
                                    message = 'New'
                                }
                            }
                    } else if ( years == 0 && months > 0 ) {
                        if ( months == 1 ) {
                            message = months + " Month Ago"
                        } else {
                            message = months + " Months Ago"
                        }
                    } else if ( years > 0 ) {
                        if ( years == 1 ) {
                            message = years + " Year Ago"
                        } else {
                            message = years + " Years Ago"
                        }
                    }
                    that.gridData.unshift({
                        id					: data.id,
                        full_name			: (data.full_name == null || data.full_name == '') ? data.personal_first_name + ' ' + data.personal_last_name : data.full_name,
                        personal_first_name	: data.personal_first_name == null ? '' : data.personal_first_name,
                        personal_last_name	: data.personal_last_name == null ? '' : data.personal_last_name,
                        status				: data.param.state,
                        score				: data.scoring,
                        email				: data.email == null ? '' : data.email,
                        personal_phone		: data.personal_phone == null ? '' : data.personal_phone,
                        generatedOn			: data.created_at,
                        updated_at			: data.updated_at,
                        source				: data.source.name /* lead.source_id */,
                        color				: data.param.color,
                        statusId			: data.param.id,
                        historic			: data.historiques,
                        notes				: data.notes,
                        email_verified		: data.email_verified,
                        phone_verified		: data.phone_verified,
                        enabled				: data.enabled,
                        entry				: arrayEntry,
                        duration			: message,
                        is_duplicate        : data.is_duplicate,
                        details				: '',
						email_historiques   : data.email_historiques,
                    })
                    
                    entryLeads.forEach( function(item) {
                        that.gridColumns.forEach( function(col) {
                            if( col.title == item ) {
                                that.gridData[that.gridData.length - 1][col.column] = data.entry[item]
                            }
                        } )
                    } )
                    
                    that.leftSidebarInfo()
                }
            });

			that.scroll()
			that.$store.state.selectedPage = this.$route.name


			
		},
		beforeMount() {
			let that = this;
			that.getUserInfo();
			
		},
		filters: {
			capitalize: function (str) {
				return str.charAt(0).toUpperCase() + str.slice(1)
			},
			maxLength: function (str) {
				if( str != null && str != '' ) {
					return str.length > 18 ? str.substring(0, 18) + "...." : str
				} else {
					return ''
				}
			},
			maxLengthSource: function (str) {
				if( str != null && str != '' ) {
					return str.length > 38 ? str.substring(0, 38) + " ..." : str
				} else {
					return ''
				}
			}
		},
		updated() {
			if(this.reloadCompenent && this.checkSmartVienwsFilter == true) {
				this.getUserInfo();
				this.smartViewsFilter();
				this.$store.state.checkSmartVienwsFilter = false;
			}
		},
		computed: {
			reloadCompenent () {return this.$store.state.reloadCompenent},
			checkSmartVienwsFilter () {return this.$store.state.checkSmartVienwsFilter},
			smartViewsItem () {return this.$store.state.smartViewsItem},
        },
		watch: {
			newLead: {
				handler: function (val) {
					if( val.personal_first_name != '' || val.personal_last_name != '' ) {
						val.full_name = val.personal_first_name + ' ' + val.personal_last_name
					}
				},
				deep: true
			},
			
			dateRange: function (val) {
				
				if(val == null) {
					this.getLeads(true, 'filter')
				}
			},
			
			DuplicatesLength: function(){
				if(this.selectedLead.entry.duplicates_leads.length > 0){
					return true
				}else{
					return false
				}
			},
		}		
	}
</script>

<style lang="scss">
	@import url('https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap');
	@import url('https://cdn.jsdelivr.net/npm/remixicon@2.5.0/fonts/remixicon.css');

	.activities-tooltip{
		font-size:10px !important;
	}

	#demo .select-dropdown .multiselect-md .fa-caret-down{right: 0px;}
	#demo  .select-dropdown .multiselect-md input {
    font-weight: 400;
    font-size: 12px;
}


	.hr-e7f2f7{
		width:100%;
		height:1px;
		background-color:#e7f2f7;
	}
.bv-modalLeadDetails-header{float:left}
.bv-modalLeadDetails-header .closeme{float:left}
.bv-modalLeadDetails-header .threepoints {float:right}
.threepoints .btn{background:#fff!important}

	.canvas-wrap {
		position: relative;
		width: 300px;
		height: 300px;
		margin-left: auto;
		
		span#procent {
			display: block;
			position: absolute;
			left: 50%;
			top: 54%;
			font-size: 50px;
			transform: translate(-50%, -50%);
			color: #4e4e4e;
			text-align: center;
			font-family: sans-serif;
		}
		span#procent div span {
			font-size: 60px;
		}
		span#procent div {
			line-height: 24px;
		}
		
		span#procent::after {
			content: 'Score';
			font-size: 28px;
			color: #4e4e4e;
		}
	}
	
	#bv-modal-state {
		#bv-modal-state___BV_modal_content_ {
			box-shadow: 0px 0px 10px #ccc;
			border: 0px;
		}
	}
	#bv-modal-state___BV_modal_backdrop_ {
		background-color: transparent;
	}
	
	.m-popline {
		position: fixed;
		background-color: #fff;
		z-index: 9999;
		bottom: 25px;
		left: 25%;
		width: 48em;
		padding: 10px 0px;
		box-shadow: 0px 0px 8px #9E9E9E;
		border-radius: 2px;
		height: 70px;
		img {
			width: 34px;
		}
		.icon-close {
			position: absolute;
			right: 12px;
			top: -1px;
			color: #4a4a4a;
		}
		.show-stats {
			position: absolute;
			right: 40px;
			bottom: 25px;
		}
	}
	
	
	
	#bv-modal-leadDetails, #bv-modal-qualification {
		height:100vh;
		.comment-list {
			.icon-activity {
				padding: 12px 14px;
				font-size: 14px;
				border: 1px solid;
				border-radius: 100%;
				color: #fff;
				background-color: #1fabec;
				width: 40px;
				height: 40px;
			}
			.comment-item {
				border: 1px solid #f7f7f7;
				border-radius: 8px;
				background: #fff;
				padding: 10px 15px;
			}
		}
		
		.modal-dialog {
			width: 62em;
		}
		.modal-body {
			padding: 0px 15px;
		}
		
		.element-details {
			padding: 1rem 0rem 1rem 0rem;
			h5 {
				color: #377dff;
				display:flex;
				align-items: center;
				font-size: 18px;
				min-height: 22px;
			}
		}
		
		.popover-call {
			border: 1px solid #ccc;
			height: 40px;
			width: 40px;
			margin-left: 8px;
			border-radius: 4px;
			color: #fff;
		}
		
		.switch-leads {
			width: 130px;
			position: relative;
			.fa-chevron-right{
				position: absolute;
				top: 10em;
				z-index: 99;
				left: 66em;
			}
			.fa-chevron-left{
				position: absolute;
				top: 10em;
				z-index: 99;
				right: 13.5em;
			}
			.fa-chevron-left, .fa-chevron-right {
				color: #fff;
				background-color: #1fabec;
				border-color: #1fabec !important;
				&:hover {
					background-color: transparent;
					color: #1fabec;
				}
				
			}
			.fa {
				border: 1px solid;
				padding: 12px;
				border-radius: 4px;
				cursor: pointer;
				width: 40px;
				height: 40px;
			}
			
		}
		
		.modal-close {
			cursor: pointer;
			font-size: 28px;
			color: #333;
			margin: 0px 14px;
			padding: 0px 8px 0px 8px;
			height: 4px;
		}
		
		.nav-tabs {
			background-color: #fafafa;
		}
		
		.nav-item {
			.nav-link {
				padding: 0px;
				height: 0px;
				/* padding: 14px 12px; */
				color: #151515;
				font-weight: 600;
				border: 0;
				font-size: 14px;
				&.active {
					color: #f5523c;
					/* border-bottom: 2px solid #f5523c; */
					background-color: transparent;
				}
				&:hover {
					color: #f5523c;
				}
			}
		}
		.modal-content {
			border: 1px solid #f5f5f5 !important;
		}
	}
	
	/* #bv-modal-leadDetails___BV_modal_backdrop_ {
		opacity: 0.8 !important;
	}
	#bv-modal-leadDetails___BV_modal_backdrop_ {
		background-color: #fff !important;
	} */
	
	.tab-myleads {
		overflow-y: auto;
		height: 25em;
		font-size: 14px;
		
		.small-md {
			position: absolute;
			right: 23px;
		}
		
	}
	
	.tab-Activities {
		overflow-y: auto;
		max-height: 68vh;
	}
	
	.tab-myleads, .tab-Activities {
		input[type="text"] {
			border-color: transparent;
			&:hover {
				border-color: #ced4da;
			}
		}
	}
	
	.add-notes {
		background-color: #fff;
		border-top: 1px solid #ececec;
		border-left: 1px solid #eee;
		padding-top: 2px;
		height: 85px;
	}
	.note-textarea[disabled] {
		cursor: not-allowed;
	}
	
	.dropdown-phone-md {
		.dropdown-toggle {
			padding: 0px;
		}
		.dropdown-menu {
			li {
				.dropdown-item {
					&:hover, &:focus {
						color: #fff !important;
					}
				}
				.b-dropdown-text {
					font-size: 13px;
				}
			}
		}
	}
	
	.event_processing {
		position: fixed;
		z-index: 999;
		top: 50%;
		width: 200px;
		margin-left: 0px;
		margin-top: 0px;
		text-align: center;
		padding: 1em 0;
		left: 45%;
	}
	
	.my-Leads-md {
		
		.dropdown-md {
			.dropdown-item {
				font-size: 12px;
			}
			.dropdown-toggle {
				padding: 0px 14px;
			}
		}
		
		.dropdown-action {
			.dropdown-toggle {
				padding: 0px 4px;
				height: 25px;
				display:flex;
				align-items:center;
			}
		}
		
		/* Optional Styles */
		.person {
			background: #ccc;
			border-radius: 2px;
			width: 20%;
			margin: 0 auto 15px auto;
			padding: 15px;
			
			img {
				width: 100%;
				height: auto;
				border-radius: 2px;
			}
			
			p:first-child {
				text-transform: capitalize;
				font-size: 2rem;
				font-weight: 900;
			}
			
			.text-capitalize {
				text-transform: capitalize;
			}
		}
		
	}
	
	.move-draggable-md {
		cursor: move;
		font-size: 14px;
		font-weight: 500;
		color: #545454;
		background-color: #f5f4f4;
	}
	
	.buttonPicker {
		border-radius: 100%;
		border: 1px solid #ccc;
		height: 16px;
		width: 16px;
		vertical-align: middle;
	}
	
	.addCustomStatus {
		font-size: 14px;
		color: #2196F3;
		span {
			cursor: pointer;
		}
	}
	
	input.inputCustomStatus {
		width: 90%;
		height: 32px;
		border-radius: 4px;
		border: 1px solid #afafaf;
		display: inline-block;
		padding: 4px 5px 4px 5px;
		margin-left: 0px;
	}
	
	input {
		&.field-required {
			border-color: #e07e77;
		}
	}
	
	select[disabled] {
		cursor: not-allowed;
	}
	.statusUserAction {
		
		display: block;
		height: calc(1.5em + 0.75rem + 2px);
		padding: 0.375rem 5px 0.375rem 12px;
		font-weight: 400;
		line-height: 1.5;
		border-radius: 4px;
		color: #fff;
		font-size: 13px;
		width: 130px;
		border: 0;
		background-image: url("data:image/svg+xml;utf8,<svg fill='white' height='24' viewBox='0 0 24 24' width='24' xmlns='http://www.w3.org/2000/svg'><path d='M7 10l5 5 5-5z'/><path d='M0 0h24v24H0z' fill='none'/></svg>") !important;
	}
	
	select {
		
		-moz-appearance:none; /* Firefox */
		-webkit-appearance:none; /* Safari and Chrome */
		appearance:none;
		background-image: url("data:image/svg+xml;utf8,<svg fill='slategrey' height='24' viewBox='0 0 24 24' width='24' xmlns='http://www.w3.org/2000/svg'><path d='M7 10l5 5 5-5z'/><path d='M0 0h24v24H0z' fill='none'/></svg>");
		background-repeat: no-repeat;
		background-position-x: 96%;
		background-position-y: 8px;
		
	}
	
	.addNote {
		position: absolute;
		top: 5px;
		right: 12px;
		background: #377dff;
		border-color: #377dff;
		border-radius: 3px;
		font-weight: 500;
	}
	
	.note-textarea {
		width: 69%;
		border: 0;
		padding: 10px 5px 12px 12px;
		resize: none;
		font-size: 13px;
		overflow: hidden;
	}
	
	.input-searchZone-md {
		position: relative;
		width: 140px;
		
		.fa {
			position: absolute;
			left: 10px;
			font-weight: 400;
			font-size: 13px;
			color: #dadfe7;
		}

		button{
			background-color:transparent;
			border:0px solid transparent;
			height:26px;
			padding:0;
			margin:0;
			position:absolute;
			top:0;
			bottom:0;
			right:10px;
			margin:auto;
			
			i{
				font-weight: 400;
				font-size: 18px;
				color: #dadfe7;
			}
		}
		
		
		.input-searchZone {
			padding-left: 25px;
			font-size: 12px;
			height: 40px;
			width: 100%;
			color:#999;
			
			&::placeholder { /* Chrome, Firefox, Opera, Safari 10.1+ */
				font-size: 12px;
				color:#999;
			}
			
			&:-ms-input-placeholder { /* Internet Explorer 10-11 */
				font-size: 12px;
				color:#999;
			}
			
			&::-ms-input-placeholder { /* Microsoft Edge */
				font-size: 12px;
				color:#999;
			}
		}
	}
	
	.filter-option {
		height: 40px;
		cursor: pointer;
		border: 1px solid #ced4da;
		width: 40px;
		display: flex;
		align-items:center;
		justify-content:center;
		border-radius: 4px;
		.fa {
			font-weight: 400;
			font-size: 15px;
			color: #dadfe7;
		}
	}

	.saveView-btn{
		color:#07B1F4;
		font-size:12px;
		cursor:pointer;
		i{
			font-size:22px;
			color:#07B1F4;
			margin-right:5px;
		}
	}
	
	.lead_status_label {
		padding: 1px 10px 2px 10px;
		border-radius: 2px;
		font-size: 12px;
	}
	
	.small-md {
		font-size: 11px;
	}
	
	.md-custom-select {
		font-size: 13px;
	}
	
	.lead-enrichment {
		margin: 0 auto;
		display: block;
		width: 340px;
		padding: 1rem;
		font-size: 1.2rem;
		background: #377cff;
		border-color: #387bff;
	}
	
	.c-pointer {
		cursor: pointer;
	}
	
	.detail-enrichmens {
		.title-detail {
			line-height: 14px;
			align-items: center;
			color: rgb(48, 57, 64);
			font-size: 10px;
			font-weight: 500;
			background: rgb(245, 246, 247);
			padding: 0px 10px;
			display: flex;
			letter-spacing: 1px;
			border-radius: 2px;
			height: 22px;
		}
		.resume-detail {
			color: rgb(48, 57, 64);
			font-size: 14px;
			line-height: 22px;
			padding: 10px 10px 10px 10px;
		}
	}
	
	.select-md {
		min-height: 31px !important;
	}
	
	.search-md {
		.select-dropdown {
			.multiselect-md {
				.fa {
					color: #dadfe7;
				}
				input {
					color: #999;
				}
				.fa, input {
					font-weight: 400;
					font-size: 13px;
				}
				
			}
		}
	}
	
	.vue-daterange-picker {
		width: 100%;
		
		.reportrange-text {
			font-size: 12px;
			height: 40px;
			display: flex;
			border: 1px solid #ced4da;
			>div {
				display: flex;
				margin-top: auto;
				margin-bottom: auto;
				width: 100%;
				
				.fa-calendar {
					color: #dadfe7;
					margin-top: 2px;
				}
				
				span {
					color: #999;
					padding-left: 5px;
					padding-right: 4px;
					margin-top: 0px;
					font-size: 12px;
					font-weight:400;
					line-height: 17px;
				}
			}
		}
	}
	
	.my-Leads-md {
		.daterangepicker.openscenter {
			transform: translate(-89%) !important;
		}
	}
	
	.daterangepicker.openscenter:after, .daterangepicker.openscenter:before {
		left: 625px !important;
	}
	.applyBtn {
		border-color: #1fabec;
		background: #1fabec;
		&:hover {
			background: #1fabec;
			border-color: #1fabec;
			color: #eee;
		}
	}
	
	.range-span {
		background-color: #377dff;
		border-radius: 50px;
		color: #fff !important;
	}
	.label-range {
		font-size: 10px;
	}
	.init-dateRange {
		position: absolute;
		right: 14px;
		top: 14px;
		color: #6c757d;
	}
	
	.icon-field {
		position: absolute !important;
		top: 10px;
		left: 0px;
		padding-right:4px;
		color: #17a2b8 !important;
		font-size:13px !important;
	}
	
	#bv-modal-changeStatus {
		.modal-body {
			padding: 40px;
			.title-modal {
				font-size: 27px;
				color: #2c3348;
			}
			.p-desc {
				hr {
					margin-top: 30px;
				}
				p {
					font-size: 14px;
					color: #717171;
					margin-bottom: 30px;
				}
			}
		}
	}
	
	.text-ohmylead {
		color: #00bbf6 !important;
	}
	
	.vue-notification-group {
		padding:5px;
		width:425px !important;
		.vue-notification-wrapper {
			margin-top: 10px;
			
			div {
				
				font-size: 14px;
				display: flex;
				
				position: relative;
				padding: 10px 6px;
				border: 1px solid transparent;
				
				.icon-notify {
					font-size: 40px;
				}
				
				&.warn {
					background: #ffb648;
					border-left-color: #f48a06;
					
					.close-notify {
						color: #2c3e50;
					}
				}
				
				&.error {
					background: #E54D42;
					border-left-color: #B82E24;
				}
				
				&.success {
					/* background: #68CD86;
					border-left-color: #42A85F; #e6f5e9 */
					
					background: #e8f9f0;
					color: #155724;
					border: 1px solid #b8f0e6;
				}
				
				.content-notify {
					padding: 10px 0px 10px 14px;
					color: #2c3e50;
					font-size: 13px;
					max-width: 26em;
				}
				.close-notify {
					font-size: 18px;
					position: absolute;
					right: 18px;
					top: 12px;
					cursor: pointer;
					color: #abe6c8;
					display: block;
					padding: 3px 0px;
				}
			}
		}
	}
	#bv-modal-leadDetails{
		font-family: 'Poppins', sans-serif;

		.fs-12{
			font-size:12px !important;
		}
		.fs-13{
			font-size:13px !important;
		}
		.fs-14{
			font-size:14px !important;
		}
		.fs-15{
			font-size:15px !important;
		}
		.fs-16{
			font-size:16px !important;
		}
		.fs-17{
			font-size:17px !important;
		}
		.fw-300{
			font-weight:300 !important;
		}
		.fw-400{
			font-weight:400 !important;
		}
		.fw-500{
			font-weight:500 !important;
		}
		.fw-600{
			font-weight:600 !important;
		}
		.fw-700{
			font-weight:700 !important;
		}
		.color-black{
			color:#000 !important;
		}
		.modal-dialog{
			width: 75%;
			max-width: 75%;
			height:100vh;
			position:fixed;
			top:0;
			right:0;
			border-radius:0 !important;
			margin:0;
			@media screen and (max-width:1200px){
				width: 90%;
				max-width: 90%;
			}
			.modal-content{
				width:100%;
				height:100%;
				border-radius:0;
				.bv-modalLeadDetails-header{
					padding:10px 0;
					width:100%;
					display:flex;
					align-items:center;
					justify-content:space-between;
					button{
						/*background-color:#EEFBFF;
						color:#1FABEC;
						border:0px solid transparent;
						border-radius:5px;
						display:flex;
						align-items:center;
						font-size:15px;
						font-weight:300;
						padding:2px 10px;*/
						
						padding: 0;
						margin: 0;
						background-color: transparent;
						border: 0;
						font-size: 1.5rem;
						font-weight: 700;
						line-height: 1;
						color: #000;
						text-shadow: 0 1px 0 #fff;
						opacity: .5;
						
						&:focus{
							outline:none;
						}
						span{
							position:relative;
							width:20px;
							height:20px;

							&:before{
								content:"";
								width:15px;
								height:2px;
								background-color:#1FABEC;
								transform: rotate(45deg);;
								position:absolute;
								top:0;
								bottom:0;
								left:0;
								margin:auto;
							}
							&:after{
								content:"";
								width:15px;
								height:2px;
								background-color:#1FABEC;
								transform: rotate(-45deg);
								position:absolute;
								top:0;
								bottom:0;
								left:0;
								margin:auto;
							}
						}
					}
				}
				.border-bottom{
					border-bottom:1px solid #F3FBFE !important;
				}
				.tab-content{
					padding-bottom:57px;
					
					.tab-myleads{
						height: calc(100vh - 325px);
						padding-right:15px;
						padding-left:15px;
						
						.tab-myLeads-item{

							.leftTitles{
								display:flex;
								align-items:center;

								i{
									position:initial;
									font-size: 22px;
								}

								label{
									margin-left:25px !important;
								}
							}
						}
						.small-md {
							position: initial;
						}
						.form-control {
							font-size: 14px;
							font-weight:500;
							min-height: 24px;
							height: 30px;
							padding: 0 10px 0 0;
							
						}
					}
				}
				.nav-tabs{
					height:40px;
					border-bottom:1px solid #ECECEC;
					background-color:#fff;

					li{
						height:100%;
						//display:none;
						a{
							height:100%;
							display:flex;
							align-items:center;
							justify-content:center;
							font-weight:400;

							&:hover{
								background-color:rgba(#00BBF6,.3);
								color:#000;
								border-radius:0;
							}

							&.active{
								border-bottom: 2px solid #01A3D6;
								font-weight: 600;
								color: #000;
								background-color: #e7f0ff61;
							}
						}
					}
				}
				.bv-leadDetailsBody-actions{
					position: absolute;
					bottom: 20px;
					left: 0;
					width: 100%;
					padding:0;
					margin:0;
					background-color: #fff;
					border-top:1px solid #F3FBFE;
					.addField-btn{
						color:#1FABEC !important;
						font-size:14px;
						display:block;
						margin:0;
						display:flex;
						align-items:center;

						span{
							width:25px;
							height:25px;
							position:relative;

							&:before{
								content:"";
								width:15px;
								height:2px;
								background-color:#1FABEC;
								transform: rotate(90deg);;
								position:absolute;
								top:0;
								bottom:0;
								left:0;
								margin:auto;
							}
							&:after{
								content:"";
								width:15px;
								height:2px;
								background-color:#1FABEC;
								position:absolute;
								top:0;
								bottom:0;
								left:0;
								margin:auto;
							}
						}

					}
					.deleteField-btn{
						color:#DC3545;
						font-size:14px;
						display:flex;
						align-items:center;

						i{
							font-size:20px;
						}
					}
				}
				.bv-modalLeadDetails-footer{
					position:absolute;
					bottom:0;
					left:0;
					width:100%;
					background-color:#fff;
					padding:20px;
					display:flex;
					align-items:center;
					justify-content:space-between;
					width:100%;
					border-top:1px solid #F3FBFE;
					
					button{
						font-size:14px;
						color:#fff;
						background-color:#00bbf6;
						border:0px solid transparent;
						border-radius:4px;
						padding:8px 10px;
						display:flex;
						align-items:center;
						justify-content:space-around;
						min-width:140px;
						outline:none;

						&:focus{
							outline:none;
						}

						i{
							font-size:25px;
							color:#fff;
						}
					}
				}
				.markAsDup-link{
					font-size:12px;
					font-weight:400;
					color:#DC3545;
					text-decoration:underline;
					margin-top:9px;
					display:block;
				}
			}
			.bv-accordion{
				.card{
					border:0px solid transparent;
				}
				.card-header{
					border-bottom:1px solid #F3FBFE;
					border-top:1px solid #F3FBFE;
					&:first-child{
						border-bottom:0px solid transparent;
					}
					button{
						background-color:#fff;
						border:0px solid transparent;
						display:flex;
						align-items:center;
						justify-content:space-between;
						color:#000;
						font-size:16px;
						font-weight:700;
						-webkit-box-shadow: 0px 0px 0px 0px rgba(0,0,0,0);
						-moz-box-shadow: 0px 0px 0px 0px rgba(0,0,0,0);
						box-shadow: 0px 0px 0px 0px rgba(0,0,0,0);
						.title{
							display:flex;
							align-items:center;
							span{
								display:inline-block;
								background-color:#DC3545;
								width:22px;
								height:22px;
								border-radius:100%;
								color:#fff;
								display:flex;
								align-items:center;
								justify-content:center;
								font-size:13px;
								font-weight:600;
								margin-left:10px;
							}
						}
						.status-arrow{
							i{
								font-size:24px;
								color:#000;
							}
						}
					}
				}
				.card-body{
					background-color:#F3FBFE;
					height: calc(100vh - 140px);
					overflow-y: auto;
					.bv-accordionDuplicate-container{
						.bv-accordionDuplicate-content{
							.bv-accordionDuplicate-item{
								background-color:#fff;
								border-radius:15px;
								padding:12px;
								margin:10px 0;
								.bv-accordionDuplicateItem-header{
									h3{
										font-size:18px;
										font-weight:600;
										color:#000;
									}

									.bv-accordionDuplicateItem-time{
										color:#8C8C8C;
										font-size:14px;
										font-weight:500;
									}
								}
								.bv-accordionDuplicateItem-content{
									display:flex;
									align-items:flex-end;
									justify-content:space-between;
									.bv-accordionDuplicateItem-infos{
										p{
											color:#8C8C8C;
											font-size:14px;
											font-weight:500;
											margin-bottom:5px;

											&:last-child{
												margin-bottom:0px;
											}
										}

									}
									.bv-accordionDuplicateItem-view{
										button{
											display:flex;
											align-items:center;
											justify-content:center;
											background-color:#F0F0F0;
											border:0px solid transparent;
											color:#1D2841;
											padding:5px 12px;
											border-radius:5px;
											margin-bottom:5px;
											ouline:none;

											i{
												margin-right:6px;
											}

											&:focus{
												outline:none;
											}
										}
									}
								}
							}
						}
					}
					&.bv-accordionActivities-cardBody{
						padding:0;
						.bv-accordionActivities-container{
							display:flex;
							flex-direction:column;
							justify-content:space-between;
							height:100%;
							padding:15px 15px 0 15px;
							.bv-accordionActivities-content{
								height: calc(100% - 85px);
								overflow-y: auto;
								overflow-x: hidden;

								.tab-Activities{
									height:100% !important;
									max-height:100% !important;
								}
							}
							.add-notes{
								border-left:0px solid transparent;
								position: absolute;
								bottom: 0;
								left: 15px;
								width: 100%;
							}
						}
					}

				}
			}
		}
		.bv-modalLeadDetails-leftSide{

		}
		.bv-modalLeadDetails-rightSide{
			position:relative;
			.bv-callDetails{
				background-color:#fff;
				width:100%;
				height:100%;
				position:absolute;
				top:0;
				left:0;
				border-radius:15px;
				box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
				z-index:1;
				border:1px solid #E5E5E5;
				&:before{
					content: "\a";
					border-style: solid;
					border-width: 8px 13px 8px 0;
					border-color: transparent #E5E5E5 transparent transparent;
					position: absolute;
					left: -12px;
					top: 34px;
				}
				&:after{
					content: "\a";
					border-style: solid;
					border-width: 7px 12px 7px 0;
					border-color: transparent #fff transparent transparent;
					position: absolute;
					left: -11px;
					top: 35px;
				}
				&.withoutDetails{
					height:auto;
					margin-top: 15px;

					&:before{
						top: 21px;
					}
					&:after{
						top: 22px;
					}
				}
				.bv-callDetails-container{
					height:100%;
					.bv-callDetails-content{
						padding:15px;
						height:100%;
						.bv-callDetails-header{
							text-align:center;
							position:relative;
							h3{
								font-size:15px;
								color:#000;
								font-weight:700;
							}
							.bv-callDetailsHeader-actions{
								position:absolute;
								top:0;
								bottom:0;
								right:0;
								display:flex;
								align-items:center;
								justify-content:flex-end;
								button{
									width:30px;
									height:30px;
									background-color:#EEFBFF;
									border:0px solid transparent;
									color:#1FABEC;
									display:flex;
									align-items:center;
									justify-content:center;
									border-radius:100%;
									outline:none;
									margin-left:10px;
									i{
										font-size:16px;
									}

									&.rotate-45{
										transform: rotate(45deg);
									}
								}
							}
						}
						.bv-callDetails-deviceStep1{
							display:flex;
							flex-direction:column;
							align-items:center;
							justify-content:center;
							height:100%;
							.bv-callDetailsStep1-img{
								background-color:#EEFBFF;
								width:130px;
								height:130px;
								border-radius:100%;
								display:flex;
								align-items:center;
								justify-content:center;
							}
							p{
								font-size:14px;
								color:#8C8C8C;
								font-weight:500;
								text-align:center;
								margin-top:10px;
							}
							.connect-btn{
								background-color:#6CB871;
								border:0px solid transparent;
								border-radius:6px;
								width:100%;
								max-width:200px;
								text-align:center;
								font-size:14px;
								color:#fff;
								font-weight:500;
								padding:8px 10px;
								cursor:pointer;
								outline:none;
							}
							.or-txt{
								font-size:14px;
								color:#8C8C8C;
								font-weight:500;
								text-align:center;
								width:100%;
								max-width:150px;
								position:relative;
								margin-top:10px;
								&:before{
									content:"";
									height:1px;
									background-color:#707070;
									width:40%;
									position:absolute;
									top:0;
									bottom:0;
									left:0;
									margin:auto;
								}
								&:after{
									content:"";
									height:1px;
									background-color:#707070;
									width:40%;
									position:absolute;
									top:0;
									bottom:0;
									right:0;
									margin:auto;
								}
							}
							a{
								text-decoration:none;
								color:#6CB871;
								font-size:14px;
								font-weight:500;
								text-align:center;
								margin-top:10px;
							}
						}
						.bv-callDetails-deviceStep2{
							display:flex;
							flex-direction:column;
							align-items:center;
							justify-content:center;
							height:100%;
							.bv-callDetailsStep2-img{
								background-color:#EEFBFF;
								width:160px;
								height:160px;
								border-radius:100%;
								display:flex;
								align-items:end;
								justify-content:center;

								svg{
									height:90%;
									width:auto;
								}
							}
							.connect-btn{
								background-color:#6CB871;
								border:0px solid transparent;
								border-radius:6px;
								width:90%;
								text-align:center;
								font-size:14px;
								color:#fff;
								font-weight:500;
								padding:8px 10px;
								cursor:pointer;
								outline:none;
								margin-top:10px;
								display:flex;
								align-items:center;
								justify-content:center;
								i{
									font-size:20px;
									margin-right:5px;
									line-height:20px;
								}
								&.hang-up{
									background-color:#E93529;

									i{
										transform:rotate(135deg);
									}
								}
							}
							.bv-input{
								margin-top:10px;
								width:90%;
								input{
									border:1px solid #B3B3B3;
									border-radius:6px;
									width:100%;
									min-height:38px;
									color:#1D2841;
									padding:0 10px;
								}
							}
							.toRing-content{
								text-align:left;
								width:100%;
								margin-top:10px;

								h4{
									font-size:15px;
								}

								.progress-bar{
									background-color:#1FABEC;
								}

								&.hang-up{
									.progress-bar{
										background-color:#69B96E;
									}
								}
							}
							.call-timer{
								text-align:center;
								margin-top:10px;

								span{
									font-size:15px;
									font-weight:700;
									color:#000;
								}
							}
						}
						.bv-callDetails-moreDetails{
							height:100%;
						}
						.bv-callDetails-hiddenDetails{
							.bv-callDetails-header{
								display:flex;
								align-items:center;
								justify-content:space-between;

								h4{
									font-size:14px;
									color:#000;
									font-weight:500;
									margin:0;
								}

								.call-timer{
									margin-left:10px;
									span{
										font-size:14px;
										color:#000;
										font-weight:700;
									}
								}


								.bv-callDetailsHeader-actions{
									.hangUp-btn{
										background-color:#E93529;
										color:#fff;
										transform:rotate(135deg);
									}
								}
							}
						}
					}
				}

			}
		}
	}

	.oml-vueEditor{
		display:flex;
		flex-direction: column-reverse;
		border:1px solid #E8E8E8;
		border-radius:6px;
		
		

		.ql-container{
			height: calc(100vh - 530px);
			min-height: 50px;
			
			&.ql-snow{
				border:0px solid transparent !important;
			}
		}

		.ql-formats{
			button{
				width:22px !important;

				svg{
					width:16px !important;
					height:16px !important;
				}
			}
		}

		.ql-toolbar{
			border-left:0px solid transparent !important;
			border-right:0px solid transparent !important;
			box-shadow: rgba(17, 17, 26, 0.1) 0px 0px 16px;
			position:relative;
			padding-top: 3px !important;
			padding-bottom: 0px !important;

			/*&:before{
				content:"";
				width:50px;
				height:100%;
				background-color:#fff;
				position:absolute;
				top:0;
				right:100%;
			}

			&:after{
				content:"";
				width:50px;
				height:100%;
				background-color:#fff;
				position:absolute;
				top:0;
				left:100%;
			}*/

			&>span{
				border-right:1px solid #d9d9d9;
				margin-bottom: 3px !important;
				min-height: 28px;
				margin-right:0px !important;
				padding:0 5px;

				&:last-child{
					border-right:0px solid transparent;
				}
			}

			.ql-header{
				width:92px !important;
			}

			.ql-size{
				width:72px !important;
			}

			.ql-font{
				width:86px !important;
			}

			
			.ql-formats{
				.ql-placeholder{
					min-width:92px;
				}
			}
		}
	}
	
	
	.modal#bv-modal-leadDetails .modal-dialog {
		position: fixed !important;
		margin: auto !important;
	}
	.modal#bv-modal-leadDetails.fade{
		-webkit-transition: initial;
		transition: initial;
		opacity:1 !important;
	}
	.modal#bv-modal-leadDetails.fade .modal-dialog {
		right: -75% !important;
		opacity:1 !important;
		transform: initial !important;
		transition: all 0.6s !important;
	}
	.modal#bv-modal-leadDetails.fade.show .modal-dialog {
		right: 0 !important;
		opacity:1 !important;
		transition: all 0.6s !important;
	}
	
	.modal-actions{
		display:flex;
		align-items:flex-end;
		justify-content: flex-end;
		height:100%;

		button{
			padding:6px 16px;
			min-width:140px;
			font-size:14px;

			&.cancel-btn{
				background-color:#fff;
				border:1px solid #8d8d8d;
				border-radius:5px;
				color:#8d8d8d;
				height:40px;
			}

			&.save-btn{
				background-color:#06aff3;
				border:1px solid #06aff3;
				border-radius:5px;
				color:#fff;
			}
		}
	}
	
	.ql-editor{
		min-height: auto !important;
		max-height: calc(100vh - 536px) !important;
		height: calc(100vh - 536px) !important;
	}
	.quillWrapper .ql-picker-label{
		font-size:12px !important;
	}
	.ql-snow .ql-toolbar button svg, .quillWrapper .ql-snow.ql-toolbar button svg{
		width:18px !important;
		height:18px !important;
	}
	.w-30px{
		width:30px;
	}
	
	.w-62px{
		width:62px;
	}
	
	.w-85px{
		width:85px;
	}
	
	.w-125px{
		width:125px;
	}
	
	.h-41px{
		height:41px;
	}





	.oml-detailsLead-popup{
			background-color:#fff;
			width:0;
			height:100vh;
			position:fixed;
			top:0;
			right:-800px;
			transition:all 1s;
			z-index:999;
			box-shadow: rgba(0, 0, 0, 0.1) 0px 10px 15px 9px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px;
			opacity:0;
			
			&.active{
				width:73%;
				right:0;
				opacity:1;
				transition:all 0.5s;

				@media screen and (max-width:1220px){
					width:90%;
				}
			}
			
			
			
			.oml-detailsLead-header{
				display:flex;
				align-items:center;
				justify-content:space-between;
				padding:5px 10px;
				
				.oml-detailsLeadHeader-left{
					button{
						&.oml-detailsLead-closeBtn{
							background-color:transparent;
							border:0;
							color:#000;
							
							i{
								font-size:22px;
							}
						}
					}
				}
				
				.oml-detailsLeadHeader-right{
					display:flex;
					align-items:center;
					justify-content:flex-end;
					
					.oml-detailsLead-nav{
						display:flex;
						align-items:stretch;
						
						button{
							border:1px solid #1fabec;
							background-color:transparent;
							border-radius:5px;
							color:#1fabec;
							display:flex;
							align-items:center;
							justify-content:center;
							padding:0 8px;
							
							i{
								font-size:20px;
							}
							
							&.oml-detailsLead-prev{
								border-radius:5px 0 0 5px;
								border-right:0;
							}
							&.oml-detailsLead-next{
								border-radius:0 5px 5px 0;
							}
						}

						
					}
					
					.dropdown{
						i.ri-more-2-fill{
							font-size:22px;
							color:#000;
						}
						
						ul{
							padding:0px !important;

							&.dropdown-menu{
								li{
									a{
										display:flex;
										align-items:center;
										
										i{
											font-size:20px;
											margin-right:5px;
										}
									}
									
									&.sendTo-btn{
										border-bottom:1px solid #ececec;
										position:relative;

										

										form{
											display:flex;
											align-items:center;
											justify-content:space-between;
											padding:5px 10px;

											i{
												font-size:15px;
												color:#b3b3b3;
											}

											& > div{
												display:flex;
												align-items:center;
												color:#1d2841;
												font-size:12px;

												i{
													font-size:15px;
													color:#b3b3b3;
													margin-right:5px;
												}
											}

											position:relative;
										
											.oml-detailsLeadSendTo-workspaces{
												border:1px solid #e2e2e2;
												background-color:#fff;
												border-radius:10px;
												position:absolute;
												top:0;
												right:calc(100% + 10px);
												min-width:290px;
												display:none;

												&:before{
													content:"";
													width: 0; 
													height: 0; 
													border-top: 10px solid transparent;
													border-bottom: 10px solid transparent; 
													border-left:10px solid #e2e2e2;
													position:absolute;
													top:15px;
													left:calc(100% - 0px);
												}

												&:after{
													content:"";
													width: 0; 
													height: 0; 
													border-top: 10px solid transparent;
													border-bottom: 9px solid transparent; 
													border-left:11px solid #fff;
													position:absolute;
													top:15px;
													left:calc(100% - 1px);
												}
												
												.oml-detailsLeadSendToWorkspace-content{
													padding:15px;
													
													h3{
														font-size:13px;
														color:#000;
														font-weight:500;
													}
													
													ul{
														list-style:none;
														padding:0;
														margin:0;
														max-height:120px;
														overflow-y:auto;
														
														li{
															display:flex;
															align-items:center;
															justify-content:space-between;
															padding:5px 0;
															
															.workspace-item{
																display:flex;
																align-items:center;
																cursor:pointer;
																
																i{
																	color:#b3b3b3;
																	opacity:0;
																}
																
																span{
																	display:inline-block;
																	color:#000;
																	font-size:12px;
																	font-weight:400;
																}
															}
															
															&.checked{
																.workspace-item{
																	i{
																		opacity:1;
																	}
																}
															}
															
															.workspace-total{
																display:inline-block;
																background-color:#4CAF50;
																border-radius:7px;
																padding:2px 6px;
																font-size:7px;
																color:#fff;
																line-height:8px;
															}
														}
													}

													.oml-btn{
														background-color:#4caf50 !important;
														border:1px solid #4caf50 !important;
														width: 70%;
														margin: 0 auto;
														height: 28px !important;
														margin-top: 10px;
														display: flex;
														align-items: center;
														justify-content: center;
														cursor:pointer;
													}
												}
												
												.oml-detailsLeadSendToWorkspace-footer{
													border-top:1px solid #e2e2e2;
													padding:8px 15px;
													
													.submitBtn, .bulkBtn{
														border:1px solid #4caf50;
														font-size:11px;
														border-radius:5px;
														background-color:transparent;
														color:#4caf50;
														width:100%;
														display:flex;
														align-items:center;
														justify-content:center;
														padding:4px 0;
														cursor:pointer;
														
														i{
															margin-right:5px;
															font-size:12px;
															color:#4caf50;
														}

														&.disabled{
															border:1px solid #dadfe7;
															color:#dadfe7;

															i{
																color:#dadfe7;
															}
														}
													}
												}
											}
											
											&:hover{
												.oml-detailsLeadSendTo-workspaces{
													display:block;
												}
											}
										}
									}
									
									&.delete-btn{
										a{
											color:#f3533b;
											font-size:13px;
											padding:5px 10px;
											
											&:focus{
												color:#fff;
											}

											i{
												font-size:15px;
												color:#f3533b;
												margin-right:5px;
											}
										}
									}
								}
							}
						}
					}
				}
			}

			.oml-detailsLead-body{
				display:flex;
				align-items:stretch;
				width:100%;

				.oml-detailsLeadBody-left{
					display:flex;
					align-items:stretch;
					flex-direction: column;
					width:65%;

					.oml-detailsLeadLeft-header{
						display:flex;
						justify-content:space-between;
						padding:0px 15px 8px 15px;

						.oml-detailsLeadLeft-infos{
							width:45%;

							.oml-detailsLeadLeft-name{
								display:flex;
								align-items:center;

								h3{
									font-size:18px;
									font-weight:700;
									margin:0;
									color:#1d2841;
									white-space: nowrap;
									overflow: hidden !important;
									text-overflow: ellipsis;
								}

								button,:any-link{
									width:30px;
									height:30px;
									border-radius:5px;
									border:0px solid transparent;
									margin-left:10px;
									color:#fff;
									display:flex;
									align-items:center;
									justify-content:center;
									text-decoration:none;
									flex-shrink: 0;
									
									i{
										font-size:18px;
									}

									&.call-btn{
										background-color:#4caf50;
									}

									&.whatsapp-btn{
										background-color:#33e555;
									}
								}
							}

							p{
								font-size:13px;
								margin-bottom:0px;
								color:#1d2841;
								/*text-transform: ;display:flex;
								align-items:center;*/
								white-space: nowrap;
								overflow: hidden !important;
								text-overflow: ellipsis;

								b{
									margin-right:5px;

									/*&.source{
										width:78px;
									}

									&.generatedOn{
										width:110px;
									}*/
								}

								span{
									
									/*display:inline-block;
									max-width:225px;*/
								}
								
							}
						}

						.oml-detailsLeadLeft-actions{
							width:55%;

							.multiselect{
								margin:0 10px;
								width:150px;
								cursor:pointer;

								.multiselect__single,.multiselect__placeholder{
									white-space:nowrap;
								}

								.multiselect__option--highlight{
									color:#000 !important;
								}

								.multiselect__content-wrapper{
									width:auto;
									min-width:100%;

									.multiselect__element{
										.multiselect__option{
											background-color:transparent !important;

											span{
												font-size:13px;
												font-weight:400;
											}

											&.multiselect__option--selected{
												background-color:transparent !important;
												padding-left:25px;
												position:relative;

												&:before{
													content:"\EB7B";
													font-family: remixicon!important;
													font-size:16px;
													height:16px;
													width:16px;
													position:absolute;
													right:100%;
													top:0;
													left:0;
													bottom:0;
													margin:auto;
													color:#b3b3b3;
												}

												span{
													font-size:13px;
													font-weight:600;
													color:#000 !important;
												}
											}

											&:hover, &:focus{
												background-color:transparent !important;
												color:#000 !important;
											}
										}
									}
								}

								.multiselect__tags{
									background-color:transparent;

									.multiselect__single{
										background-color:transparent;
										overflow:hidden;
										font-size:14px;
										white-space: nowrap;
										overflow: hidden !important;
										text-overflow: ellipsis;
									}
								}

								&.statusSelect{
									border-radius:5px;
									border:0;

									
								}
								
							}

							.duplicateBtn{
								background-color:transparent;
								border:0;
								color:#dc3545;
								text-decoration:underline;
								margin-top:10px;
								font-size:13px;
							}

							.statusUserAction{
								width:150px;
								padding-right:25px;
							}
						}
					}

					.oml-detailsLeadLeft-content{
						height:100%;
						padding:0px 15px 15px 15px;

						.tabs{
							ul{
								width:100%;
								justify-content:start;

								li{
									a{
										padding:10px 20px;
									}
								}
							}

							.tab-content{
								height: calc(100vh - 216px);
								position: relative;
								padding: 10px 15px;
								overflow-y: auto;
								overflow-x:hidden;

								.oml-leadDetails-container{

									.oml-leadDetails-item{
										display:flex;
										align-items:center;
										justify-content:space-between;
										border-bottom:1px solid #f3fbfe;
										padding:10px 0;

										&:first-child{
											padding-top:5px;
										}

										.oml-leadDetails-label{
											display:flex;
											align-items:center;
											font-size:15px;

											i{
												font-size:20px;
												color:#1fabec;
												margin-right:10px;
											}
										}

										.oml-leadDetails-value{
											display:flex;
											align-items:center;
											width:60%;

											input{
												text-align:right;
												border:0;
												font-size:13px;
												border-radius: 4px;
												height: 40px;
												text-align: right;
												padding-right: 10px;
												border:1px solid transparent;
												background-color:transparent;
												margin-right:-10px;
												width:100%;

												&:hover,&:focus{
													border:1px solid #ced4da;
													background-color:#fff;
												}
											}
										}

										&.newField{
											background-color:#f8fdff;
											margin-left:-9px;

											.oml-leadDetailsLabel-textfield{
												.oml-leadDetails-input{
													border-radius:4px;
													background-color:transparent;
													height:40px;
													position:relative;

													&:hover,&:focus{
														border:1px solid #ced4da;
													}

													input{
														padding-left:30px;
														border:0;
														height:100%;
														font-size:13px;
														min-width:290px;
														border-radius:4px;
														background-color:transparent;

														&::placeholder{
															font-size:13px;
														}

														&:hover,&:focus{
															background-color:#fff;
														}
													}

													i{
														font-size:20px;
														position:absolute;
														top:0;
														bottom:0;
														left:8px;
														height:20px;
														margin:auto;
														color:#1fabec;
													}
													
												}
											}	

											.oml-leadDetailsValue-textfield{
												margin-right:-10px;

												input{
													background-color:transparent;
													border:0;
													height:100%;
													font-size:13px;
													min-width:200px;

													border-radius:4px;
													height:40px;
													text-align:right;
													padding-right:10px;

													&:hover,&:focus{
														border:1px solid #ced4da;
														background-color:#fff;
													}
												}
											}
										}
										
									}

									.oml-leadDetails-actions{
										margin-top:15px;
										position:sticky;
										bottom:-10px;
										left:0;
										width:100%;
										background-color:#fff;
										padding:10px 0 0 0;

										.leftSide{
											display:flex;
											align-items:center;
											margin-left:-15px;
										}

										button{
											border-radius:3px;
											padding:4px 10px;
											background-color:transparent;
											border:0px solid transparent;
											font-size:14px;
											font-weight:500;
											display:flex;
											align-items:center;
											margin:0 10px 0 0;

											i{
												font-size:20px;
												margin-right:6px;
											}
											&.addField-btn{
												color:#1fabec;

												&:focus{
													background-color:rgba(#1fabec,0.1);
												}
											}

											&.minusField-btn{
												color:#dc3545;

												&:focus{
													background-color:rgba(#dc3545,0.1);
												}
											}
										}
									}
								}



								.oml-sendEmail-container{
									.oml-sendEmail-content{
										.oml-addNewTemp{
											width:30px;
											height:30px;
											border:1px solid #1fabec !important;
											border-radius:3px !important;
											background-color:transparent;
											display:flex;
											align-items:center;
											justify-content:center;

											i{
												font-size:22px;
												color:#1fabec;
											}

											span{
												width:18px;
												height:1px;
												background-color:#1fabec;
												position:relative;
												display:inline-block;

												&:after{
													content:"";
													height:18px;
													width:1px;
													background-color:#1fabec;
													position:absolute;
													top:0;
													bottom:0;
													left:0;
													right:0;
													margin:auto;
												}
											}
										}

										label{
											font-size:14px;
										}

										input,select{
											min-height:40px;
											font-size:13px !important;
											color:#1D2841;
											border:1px solid #E8E8E8;

											&::placeholder{
												font-size:13px !important;
												color:#868C9A;
											}

											&:disabled{
												background-color:#fff;
											}
										}

										#template_body{
											height:calc(100vh - 672px);
											min-height:100px;

											.ql-editor{
												height:100% !important;

												&:before{
													font-size:13px !important;
													font-style:initial;
													color:#868C9A;
												}

												p{
													font-size:13px !important;
													color:#1D2841;
												}
											}
										}
									}
								}

								.oml-calendly-container{
									height:100%;
									width:100%;
									display:flex;
									align-items:center;
									justify-content:center;

									.oml-calendly-noResult{
										text-align:center;
										margin-top:10vh;

										img{
											margin-bottom:20px;
											width:150px;
										}

										p{
											font-size:14px;
											color:#8c8c8c;
											margin-bottom:2Opx;
										}

										button{
											min-width:150px;
										}
									}

									.ac-containeer{
										width:100%;

										._3TGGk2HtkH._3xUizGUSyE{
											background-color:transparent !important;
										}

										iframe{
											border:0px solid transparent;
											height:calc(100vh - 242px);
											
										}
									}
								}
							}
						}
					}
					
				}

				.oml-detailsLeadBody-right{
					width:35%;

					.tabs{
						ul{
							width:100%;
							justify-content:start;

							li{
								a{
									padding:10px 20px;
								}
							}
						}

						.nav-item {
							.oml-countDup-title{
								width:18px;
								height:18px;
								background-color:#c5473b;
								border-radius:100%;
								display:flex;
								align-items:center;
								justify-content:center;
								margin-left:5px;
								color:#fff;
								font-size:10px;
							}
						}

						.tab-content{
							height:calc(100vh - 205px);

							.oml-activities-container{
								.oml-activities-content{
									display:flex;
									flex-direction:column;
									align-items:stretch;
									justify-content:space-between;
									height:calc(100vh - 97px);
									background-color:#fafeff;

									.oml-activities-body{
										background-color:#fafeff;
										padding:10px 10px 10px 80px;
										overflow:hidden;
										overflow-y:auto;

										.oml-activities-actLine{
											position:relative;
											min-height:100%;

											&:before{
												content:"";
												width:2px;
												background-color:#ececec;
												position:absolute;
												top:20px;
												bottom:0;
												left:-37px;
											}

											&:after{
												content:"";
												width:6px;
												background-color:#fafeff;
												position:absolute;
												bottom:0;
												left:-39px;
												height:40px;
											}

											.oml-actLine-item{
												position:relative;
												border-radius:8px;
												box-shadow: rgba(0, 0, 0, 0.1) 0px 4px 12px;
												margin:20px 0;

												&:before{
													content:"";
													width: 0; 
													height: 0; 
													border-top: 8px solid transparent;
													border-bottom: 8px solid transparent; 
													position:absolute;
													top:0;
													bottom:0;
													right:100%;
													margin:auto;
												}

												.oml-actLineItem-icon{
													width:50px;
													height:50px;
													border-radius:100%;
													display:flex;
													align-items:center;
													justify-content:center;
													position:absolute;
													top:0;
													bottom:0;
													right:calc(100% + 11px);
													margin:auto;
													z-index:1;
													
													i{
														font-size:25px;

														&.icon{
															font-size:16px;
														}
													}
												}
												.oml-actLineItem-content{
													padding:8px;

													.oml-actLineItem-values{
														p{
															width:50%;
															white-space: nowrap;
															overflow: hidden !important;
															text-overflow: ellipsis;
														}
													}

													p{
														font-size:12px;
														margin-bottom:3px;
														display:flex;
														align-items:center;
														color:#1D2841;
														

														b{
															white-space:nowrap;
															font-weight:600;
															text-transform: capitalize;
															margin-right:3px;
															margin-left:5px;

															&:first-child{
																margin-left:0px;
															}
														}

														&.header{
															color:#5F5F5F;
															font-size:12px;
															display:inline-block;
														}

														span{
															width:80%;

															&.substr{
																white-space: nowrap;
																overflow: hidden !important;
																text-overflow: ellipsis;
															}

															p{
																display:inline-block;
															}
														}
													}

													.color-red{
														color:#e61615;
													}

													.color-blue{
														color:#2cafed;
													}

													a{
														text-decoration:none;
														color:#2cafed;
														font-size:13px;
													}

													button.span{
														text-decoration:none;
														color:#2cafed;
														font-size:13px;
														display:block;
														background-color:transparent;
														border:0;
														font-size:12px;
														padding-left:0px;
													}
												}

												&.light-blue{
													background-color:#fff;

													&:before{
														content:"";
														border-right:8px solid #fff;
													}

													.oml-actLineItem-icon{
														background-color:#f2fafe;
														
														i{
															color:#1fabec;
														}
													}
												}

												&.light-yellow{
													background-color:#fff8cf;

													&:before{
														content:"";
														border-right:8px solid #fff8cf;
													}

													.oml-actLineItem-icon{
														background-color:#fff8cf;
														
														i{
															color:#f2d739;
														}
													}
												}

												&.email-box{
													background-color:#fff;

													&:before{
														content:"";
														border-right:8px solid #fff;
													}

													.oml-actLineItem-icon{
														background-color:#fdf7db;
														
														i{
															color:#e2bd21;
														}
													}
												}

												&.light-green{
													background-color:#fff;

													&:before{
														content:"";
														border-right:8px solid #fff;
													}

													.oml-actLineItem-icon{
														background-color:#e9f5e9;
														
														i{
															color:#4caf4f;
														}
													}
												}
											}
										}
									}
									.oml-activities-footer{
										height:150px;
										background-color:#fffde1;
										border-top:1px solid #ececec;
										display:flex;
										flex-direction:column;
										align-items:end;
										justify-content:end;
										
										textarea{
											background-color:transparent;
											border:0;
											padding:10px;
											display:block;
											width:100%;
											resize: none;
											font-size:14px;
										}

										button{
											border-radius:4px;
											font-family: poppins,sans-serif;
											font-size:14px;
											font-weight:400;
											color:#fff;
											line-height: 1.5;
											height:40px;
											background-color:#4caf50;
											border:0;
											padding:0 20px;
											margin:5px;

											&.disabled{
												background-color:#d2d2d2;
												color:#9d9c9c;
											}
										}


									}
								}
							}


							.oml-tabDuplicate-container{
								.oml-tabDuplicate-content{
									height:calc(100vh - 97px);
									background-color:#fafeff;
									overflow-y:auto;
									padding:10px;

									.oml-tabDuplicate-item{
										background-color:#fff;
										box-shadow: rgba(0, 0, 0, 0.05) 0px 1px 2px 0px;
										border-radius:6px;
										padding:12px;
										margin:10px 0;

										.oml-tabDuplicateItem-header{
											h3{
												font-size:14px;
												font-weight:400;
												color:#1D2841;
											}

											.oml-tabDuplicateItem-time{
												color:#949494;
												font-size:12px;
												font-weight:400;
											}
										}
										.oml-tabDuplicateItem-content{
											display:flex;
											align-items:flex-end;
											justify-content:space-between;

											.oml-tabDuplicateItem-infos{
												p{
													color:#797979;
													font-size:12px;
													font-weight:300;
													margin-bottom:0px;

													b{
														font-weight:500;
													}

													&:last-child{
														margin-bottom:0px;
													}
												}

											}
											.oml-tabDuplicateItem-view{
												button{
													display:flex;
													align-items:center;
													justify-content:center;
													background-color:#F0F0F0;
													border:0px solid transparent;
													color:#1D2841;
													padding:5px 12px;
													border-radius:5px;
													margin-bottom:5px;
													outline:none;

													i{
														margin-right:6px;
													}

													&:focus{
														outline:none;
													}
												}
											}
										}
									}
								}
							}
						}
					}
				}
			}
		}
		
		.oml-detailsLead-overlay{
			background-color:rgba(0,0,0,0.3);
			width:100%;
			height:100vh;
			position:fixed;
			top:0;
			left:0;
			z-index:999;
		}

		.bulkActions-dropdown{
			.dropdown-item{
				padding:5px 10px;
			}
			& > .dropdown-menu{
				& > li{
					& > form{
						padding:0.25rem 0;
					}

					&.bulkActions-sendTo{
						& > form{
							padding:0.25rem 10px;
						}
					}
				}
			}
			.bulkActions-sendTo{
				border-top:1px solid #dedede;

				form{
					display:flex;
					align-items:center;
					justify-content:space-between;
					padding:5px 10px;

					i{
						font-size:15px;
						color:#b3b3b3;
					}

					& > div{
						display:flex;
						align-items:center;
						color:#1d2841;
						font-size:12px;

						i{
							font-size:15px;
							color:#b3b3b3;
							margin-right:5px;
						}
					}

					position:relative;
                                    
					.oml-detailsLeadSendTo-workspaces{
						border:1px solid #e2e2e2;
						background-color:#fff;
						border-radius:10px;
						position:absolute;
						top:0;
						left:calc(100% + 10px);
						min-width:290px;
						display:none;

						&:before{
							content:"";
							width: 0; 
							height: 0; 
							border-top: 10px solid transparent;
							border-bottom: 10px solid transparent; 
							border-right:10px solid #e2e2e2;
							position:absolute;
							top:10px;
							right:calc(100% - 0px);
						}

						&:after{
							content:"";
							width: 0; 
							height: 0; 
							border-top: 10px solid transparent;
							border-bottom: 9px solid transparent; 
							border-right:11px solid #fff;
							position:absolute;
							top:10px;
							right:calc(100% - 1px);
						}
						
						.oml-detailsLeadSendToWorkspace-content{
							padding:15px;
							
							h3{
								font-size:13px;
								color:#000;
								font-weight:500;
							}
							
							ul{
								list-style:none;
								padding:0;
								margin:0;
								max-height:120px;
								overflow-y:auto;
								
								li{
									display:flex;
									align-items:center;
									justify-content:space-between;
									padding:5px 0;
									
									.workspace-item{
										display:flex;
										align-items:center;
										cursor:pointer;
										
										i{
											color:#b3b3b3;
											opacity:0;
										}
										
										span{
											display:inline-block;
											color:#000;
											font-size:12px;
											font-weight:400;
										}
									}
									
									&.checked{
										.workspace-item{
											i{
												opacity:1;
											}
										}
									}
									
									.workspace-total{
										display:inline-block;
										background-color:#4CAF50;
										border-radius:7px;
										padding:2px 6px;
										font-size:12px;
										color:#fff;
										line-height:8px;
									}
								}
							}

							.oml-btn{
								background-color:#4caf50 !important;
								border:1px solid #4caf50 !important;
								width: 70%;
								margin: 0 auto;
								height: 28px !important;
								margin-top: 10px;
								display: flex;
								align-items: center;
								justify-content: center;
								cursor:pointer;
							}
						}
						
						.oml-detailsLeadSendToWorkspace-footer{
							border-top:1px solid #e2e2e2;
							padding:8px 15px;
							
							.submitBtn, .bulkBtn{
								border:1px solid #4caf50;
								font-size:11px;
								border-radius:5px;
								background-color:transparent;
								color:#4caf50;
								width:100%;
								display:flex;
								align-items:center;
								justify-content:center;
								cursor:pointer;
								padding:4px 0;
								
								i{
									margin-right:5px;
									font-size:12px;
									color:#4caf50;
								}

								&.disabled{
									border:1px solid #dadfe7;
									color:#dadfe7;

									i{
										color:#dadfe7;
									}
								}
							}
						}
					}
					
					&:hover{
						.oml-detailsLeadSendTo-workspaces{
							display:block;
						}
					}
				}
			}

			.oml-bulkActions-status{
				max-height:120px;
				overflow-y:auto;
			}

			.bulkActions-delete{
				border-top:1px solid #dedede;

				a{
					color:#f3533b;

					i{
						font-size:15px;
						color:#f3533b;
						margin-right:5px;
					}
				}
			}
		}
		
	.slide-fade-enter-active {
		transition: all .3s ease;
	}
	.slide-fade-leave-active {
		transition: all .3s ease;
	}
	.slide-fade-enter, .slide-fade-leave-to{
		transform: translateX(40px);
		opacity: 0;
	}

	.show-enter-active,
.show-leave-enter {
    transform: translateX(0);
    transition: all .3s linear;
}
.show-enter,
.show-leave-to {
    transform: translateX(100%);
}
.year-month-wrapper {
    background-color: #07b2f4;
}

element.style {
}

.nav-l, .nav-r {
    display: inline-block;
    width: 25px;
    background-color: #07b2f4;
    color: white;
    font-size: 16px;
    cursor: pointer;
    border: 0;
    padding: 7px;
    margin: 0;
}
.days{
    color: #07b2f4;
    font-weight: bold;
}
.activePort, .activePort:hover {
    background-color: #07b2f4;
    color: white;
}
.okButton{
    color: #07b2f4;
    font-size: 15px;
    font-weight: bold;
    padding: 0;
    float: right;
    border: 0;
    margin-right: 10px;
    margin-top: 10px;
    cursor: pointer;
    background: transparent;
}
.btn-clickstart-md {
		background-image: linear-gradient(150deg, #07b2f4 0%, #048fc6 100%) !important;
		padding: 1.3rem 5rem;
		font-size: 1.5rem;
		border-radius: 6px;
		color: #fff !important;
		border: 0;
	}
	
	.close-qualification {
		cursor: pointer;
		-webkit-transition: all 0.2s;
		font-size: 20px;
		text-decoration: none;
		color: #333;
		margin: 0px;
		border: 1px solid #000;
		padding: 0px 10px;
		border-radius: 100%;
		vertical-align: middle;
		float: right;
	}
	
	
</style>
